<template>
  <div style="width: 100%">
    <div v-if="true">
      <div class="page flex-col" style="min-height: 1458px">
        <div class="group_1 flex-col" style="min-height: 1458px;">
          <div class="box_1 flex-col justify-end" style="min-height: 1458px; background: url(/img/box-back.e1a2e92e.png) 0px 0px repeat">
            <site-header />
            <div v-if="false" class="group_2 flex-col">
              <div class="box_2 flex-row">
                <div class="flex-row" style="align-items: center;">
                  <img @click="toPath('/index')"
                       data-track-text="首页Logo"
                       aria-label="首页Logo"
                       class="image_1"
                       referrerpolicy="no-referrer"
                       src="../assets/v2/img/logo-black.png"
                  />
                  <span class="text_1">
                    <span data-track-text="首页" aria-label="首页" @click="toPath('/')">首页</span>
                    <span>
                      <el-dropdown @command="logOut">
                        <span>
                          产品
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="txtTrans" style="z-index: 1;font-weight: 800">
                            <span>
                              文本翻译
                            </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="docTrans" style="z-index: 1;font-weight: 800">
                            <span>
                              文档翻译
                            </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="mediaTrans" style="z-index: 1;font-weight: 800">
                            <span>
                              视频翻译
                              <span style="margin-left: 10px">
                                (服务升级中，敬请期待)
                                <span style="position: absolute;margin-top: -10px;margin-left: -20px;">
                                  <img src="../assets/new_icon.png" alt="">
                                </span>
                              </span>
                            </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="imgTrans" style="z-index: 1;font-weight: 800">
                            <span>
                              图片翻译
                            </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="xlsTrans" style="z-index: 1;font-weight: 800">
                            <span>
                              表格翻译
                            </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="musicTrans" style="z-index: 1;font-weight: 800">
                            <span>
                              音频翻译
                              <span style="margin-left: 10px">
                                (服务升级中，敬请期待)
                                <span style="position: absolute;margin-top: -10px;margin-left: -20px;">
                                  <img src="../assets/new_icon.png" alt="">
                                </span>
                              </span>
                            </span>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <img
                          class="thumbnail_4"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/operate.png"
                      />
                    </span>
                    <span>
                      <el-dropdown @command="logOut">
                          <span>
                            服务
                          </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="toTransPro" style="z-index: 1;font-weight: 800">
                              <span>
                                人工翻译
                              </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="standLangSet" style="z-index: 1;font-weight: 800">
                              <span>
                                医学术语
                              </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="convertDoc" style="z-index: 1;font-weight: 800">
                              <span>
                                文档转换
                              </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="mySelfDoc" style="z-index: 1;font-weight: 800">
                              <span>
                                我的文档
                              </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="webTranslate" style="z-index: 1;font-weight: 800;position: relative;">
                              <span>
                                网页翻译
                              </span>
                              <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                          </el-dropdown-item>
                          <el-dropdown-item command="smartClassify" style="z-index: 1;font-weight: 800;position: relative;">
                              <span>
                                数据分析
                              </span>
                              <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <img
                          class="thumbnail_4"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/operate.png"
                      />
                    </span>
                </span>
                </div>
                <div class="flex-row" style="align-items: center;">
          <img class="thumbnail_1"
               @click="toPath('/help')"
               data-track-text="帮助"
               aria-label="帮助"
               referrerpolicy="no-referrer"
                       src="../assets/v2/img/trans/help.png"/>
                  <span class="text_2" data-track-text="帮助" aria-label="帮助" @click="toPath('/help')">帮助</span>
                  <span class="text_2" v-if="groupUserInfo==='机构登录'"
                        data-track-text="机构登录"
                        aria-label="机构登录"
                        @click="showIframe('/login')">
                {{ groupUserInfo }}
              </span>
                  <el-dropdown @command="logOut" v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'"
                               style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">
                <span v-show="groupUserInfo!==''&&groupUserInfo!=='机构登录'" class="text_2">{{
                    groupUserInfo
                  }}</span>
                    <el-dropdown-menu v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'" slot="dropdown">
                      <el-dropdown-item v-for="(item,index) in groupUserInfos" :key="index" :command="item.name"
                                        style="z-index: 1;font-weight: 800">
                    <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">{{
                        item.name
                      }}</span>
                        <span
                            style="margin-left:10px; font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;"
                            v-if="!item.isIpScore">退出</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
          <img class="thumbnail_1"
               @click="userInfo!==''?toCenter:''"
               data-track-text="个人中心"
               aria-label="个人中心"
               referrerpolicy="no-referrer"
                       src="../assets/v2/img/trans/login.png"/>
                  <el-dropdown @command="logOut" v-if="showloginOut"
                               style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">
                  <span v-show="userInfo!==''" class="text_2">
                    {{ userInfo }}
                  </span>
                    <el-dropdown-menu v-if="showloginOut" slot="dropdown">
                      <el-dropdown-item command="toCenter" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">个人中心</span>
                      </el-dropdown-item>
                      <el-dropdown-item style="z-index: 1;font-weight: 800">
                    <span
                        style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">退出</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <span class="text_2" v-show="userInfo===''">
                  <span data-track-text="登录" aria-label="登录" @click="showIframe('/login')">登录</span>
                    /
                  <span data-track-text="注册" aria-label="注册" @click="showIframe('/register')">注册</span>
                </span>
                  <span v-if="isShowInRoaming&&showRoaming">
                  <span class="text_2">｜</span>
                  <el-popover
                      @hide="removeQrcode"
                      @show="getQrcode"
                      placement="top-start"
                      title="扫一扫开通漫游"
                      width="150"
                      trigger="hover">
                    <el-image
                        :src="qrcodeUrl"
                        fit="contain"
                        style="width: 150px; height: 150px"
                        alt="开通漫游">
                    </el-image>
                    <el-button type="text" slot="reference" class="text_2"
                               style="margin-top: 4px;cursor: pointer">开通漫游</el-button>
                  </el-popover>
                  <span style="position: absolute;margin-top: -8px;margin-left: -20px;">
                    <img src="../assets/new_icon.png" alt="">
                  </span>
                </span>
                </div>
              </div>
            </div>
            <div class="license-content" style="height: 1330px;display: flex;align-items: center;flex-flow: column;justify-content: space-around;">
              <div>
                <img class="license-image" src="../assets/yyzz.jpg" alt="营业执照" style="width: 800px;height: 600px;">
              </div>
              <div>
                <img class="license-image" src="../assets/cbxkz.jpg" alt="出版物经营许可证" style="width: 800px;height: 600px;">
              </div>
            </div>
            <site-footer />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {authServiceClient, translateServiceClient} from "@/tools/api/service";
import {outRequest, userPowerRequest, userStatusRequest} from "@/tools/api/auth-api";
import lanuagefrom from "../../languagefrom.json";
import languageto from "../../languageto.json";
import {
  parentPowerRequest,
  submitRequest,
  transTextRequest,
  uploadCountRequest,
  uploadRequest,
  uploadTipRequest,
  checkRoamingRequest,
  getEmailRequest,
  uploadTmpRequest,
  delTmpRequest,
  transTmpRequest,
  selectTmpRequest,
  submitConvertRequest,
  getMedicineDictRequest,
  selectMedicineDictSpecRequest,
  aiSendRequest,
  aiSessionPageRequest,
  delAiSessionRequest,
  createAiSessionRequest,
  aiHistoryPageRequest
} from "@/tools/api/translate-api";
import {Loading} from 'element-ui';
import languages from "../../language.json";
import LangPanel from "../components/lang_panel/LangPanel"
import {TransTmpFile, UploadFile} from "../../api/translateService_pb";
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2';
import SiteHeader from "@/components/home/SiteHeader.vue";
import SiteFooter from "@/components/home/SiteFooter.vue";

export default {
  name: "License",
  components: {
    'lang_panel': LangPanel,
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      session: {},
      createAi: false,
      showAi: false,
      sessionList: [],
      message: '',
      aiMessageTemp: {},
      specData: [],
      specQuery: '',
      query: '',
      queryCount: 0,
      checkType: 'txt',
      showLangV: -1,
      email: '',
      showExcelUploadOk: true,
      showUploadOk: true,
      showSelect: false,
      hasH5: false,
      isShowTransPro: false,
      qrcodeUrl: '',
      showRoaming: false,
      groupUserInfos: [],
      userInfo: '',
      userType: '',
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      groupUserInfo: '',
      activeLabDoc: '',
      activeLabTxt: '',
      activeLabImg: '',
      activeLabExcel: '',
      languages2: "languages",
      languages: "languages",
      originalFrom: "自动检测",
      originalTo: "中文(简体)",
      originalImgFrom: "自动检测",
      originalImgTo: "中文(简体)",
      originaltext: "",
      translatetext: "",
      terminology: "暂不使用术语",
      domain: "",
      terminologyOptions: [{
        value: '',
        label: '暂不使用术语',
        from: '',
      }, {
        value: '医学术语',
        label: '医学术语',
        from: '(中-英、英-中)',
      }],
      terminologyOptionsAll: [{
        value: '',
        label: '暂不使用术语',
        from: '',
      }, {
        value: '医学术语',
        label: '医学术语 (中-英、英-中)',
        from: '',
      }],
      domainOptions: [{
        value: '',
        label: '通用领域',
        from: '200+语种互译',
      }, {
        value: 'it',
        label: '信息技术领域',
        from: '(中-英、英-中)',
      }, {
        value: 'finance',
        label: '金融财经领域',
        from: '(中-英、英-中)',
      }, {
        value: 'machinery',
        label: '机械制造领域',
        from: '(中-英、英-中)',
      }, {
        value: 'senimed',
        label: '生物医药领域',
        from: '(中-英、英-中)',
      }, {
        value: 'novel',
        label: '网络文学领域',
        from: '(中-英)',
      }, {
        value: 'academic',
        label: '学术论文领域',
        from: '(中-英、英-中)',
      }, {
        value: 'aerospace',
        label: '航空航天领域',
        from: '(中-英、英-中)',
      }, {
        value: 'wiki',
        label: '人文社科领域',
        from: '(中-英)',
      }, {
        value: 'news',
        label: '新闻资讯领域',
        from: '(中-英、英-中)',
      }, {
        value: 'law',
        label: '法律法规领域',
        from: '(中-英、英-中)',
      }, {
        value: 'contract',
        label: '合同领域',
        from: '(中-英、英-中)',
      }],
      domainOptionsAll: [{
        value: '',
        label: '通用领域 200+语种互译',
        from: '',
      }, {
        value: 'it',
        label: '信息技术领域 (中-英、英-中)',
        from: '',
      }, {
        value: 'finance',
        label: '金融财经领域 (中-英、英-中)',
        from: '',
      }, {
        value: 'machinery',
        label: '机械制造领域 (中-英、英-中)',
        from: '',
      }, {
        value: 'senimed',
        label: '生物医药领域 (中-英、英-中)',
        from: '',
      }, {
        value: 'novel',
        label: '网络文学领域 (中-英)',
        from: '',
      }, {
        value: 'academic',
        label: '学术论文领域 (中-英、英-中)',
        from: '',
      }, {
        value: 'aerospace',
        label: '航空航天领域 (中-英、英-中)',
        from: '',
      }, {
        value: 'wiki',
        label: '人文社科领域 (中-英)',
        from: '',
      }, {
        value: 'news',
        label: '新闻资讯领域 (中-英、英-中)',
        from: '',
      }, {
        value: 'law',
        label: '法律法规领域 (中-英、英-中)',
        from: '',
      }, {
        value: 'contract',
        label: '合同领域 (中-英、英-中)',
        from: '',
      }],
      imgFromOptions: [
        {value: 'auto', label: '自动检测'},
        {value: 'zh', label: '中文'},
        {value: 'en', label: '英语'},
        {value: 'jp', label: '日语'},
        {value: 'kor', label: '韩语'},
        {value: 'fra', label: '法语'},
        {value: 'spa', label: '西班牙语'},
        {value: 'ru', label: '俄语'},
        {value: 'pt', label: '葡萄牙语'},
        {value: 'de', label: '德语'},
        {value: 'it', label: '意大利语'},
        {value: 'dan', label: '丹麦语'},
        {value: 'nl', label: '荷兰语'},
        {value: 'may', label: '马来语'},
        {value: 'swe', label: '瑞典语'},
        {value: 'id', label: '印尼语'},
        {value: 'pl', label: '波兰语'},
        {value: 'rom', label: '罗马尼亚语'},
        {value: 'tr', label: '土耳其语'},
        {value: 'el', label: '希腊语'},
        {value: 'hu', label: '匈牙利语'}
      ],
      imgToOptions: [
        {value: 'zh', label: '中文'},
        {value: 'en', label: '英语'},
        {value: 'jp', label: '日语'},
        {value: 'kor', label: '韩语'},
        {value: 'fra', label: '法语'},
        {value: 'spa', label: '西班牙语'},
        {value: 'ru', label: '俄语'},
        {value: 'pt', label: '葡萄牙语'},
        {value: 'de', label: '德语'},
        {value: 'it', label: '意大利语'},
        {value: 'dan', label: '丹麦语'},
        {value: 'nl', label: '荷兰语'},
        {value: 'may', label: '马来语'},
        {value: 'swe', label: '瑞典语'},
        {value: 'id', label: '印尼语'},
        {value: 'pl', label: '波兰语'},
        {value: 'rom', label: '罗马尼亚语'},
        {value: 'tr', label: '土耳其语'},
        {value: 'el', label: '希腊语'},
        {value: 'hu', label: '匈牙利语'}
      ],
      showTxt: false,
      showDoc: true,
      showImg: false,
      showExcel: false,
      isShowMoney: false,
      isShowFree: false,
      orderMoney: 0,
      moneys: 0,
      pages: 0,
      idData: [],
      setMailVisible: false,
      dialogTableVisible: false,
      gridData: [],
      title: '',
      isShowInRoaming: false,
      selectOption: 'selectOption',
      uploadCount: 0,
      limitCount: 20,
      count: 10,
      isUploadDisabled: true,
      isImgUploadDisabled: true,
      isExcelUploadDisabled: true,
      isShowupload: true,
      showupload: "",
      elUploadMdjy: "",
      showUpload1: true,
      showUpload2: true,
      timer: "",
      autoUpload: true,
      hasUpload: false,
      hasSendMail: false,
      lanuagesFrom: lanuagefrom,
      lanuagesTo: languageto,
      uploadform: {
        from: "auto",
        to: "zh",
      },
      uploadImgForm: {
        from: "auto",
        to: "zh",
      },
      uploadrules: {
        from: [{required: true, message: "请输入原文语言", trigger: "blur"}],
        to: [{required: true, message: "请输入目标语言", trigger: "blur"}],
      },
      fileList: [],
      uploadLoading: false,
      one: true,
      two: false,
      three: false,
      four: false,
      one2: true,
      two2: false,
      three2: false,
      lastTime: 0,
      userId: '',
      isRoamingTimer: undefined,
      isRoamingTimerOut: undefined,
      isShowNewUpload: true,
      isShowNewUploadList: false,
      tmpFileData: [],
      queryData: [],
      currentPage: 1,
      pageSize: 10,
      checkTmpList: [],
      processNum: 5,
      aiMessage: [],
      typeImg: {
        "png": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAndJREFUOE+tlM9LVFEUx8/3vhlLQspIIoiKQHrvTamEtJH+gYoWBbUw5jlZSd7XtIsWhULugqKcN6KlvjeLCNq0MIhAilAoiwjC98Zc9A9YQpiWM3NPzODEjIw/SO/y3HM+93t+3APa5INN5hEc13/LQPVaYDCBwO+lZcq8r+P6IwzsJmZBwLhtGfG8HY7nP2XwfWIh8gahmJVAReU5xTPXY+Z03q8v5R/OMWqUYtY08VJG9R1LwGBAWsYVIobjBbeY0KIUd8dj5ru1VBfvHc//IS1zZxkw6aZjDL6kQI5gToR+z+/t6GieXw+0ItBJ+e2s6DyB+ojwGHNqv5SRuf8GLhW6h4SIsMol7LbIaCXYg2G/PqyJk1mhDcUv1P8sxFVKeT1KBgfTNQshngDRAhN9ti3j4oaACdd/RAK14YWq9uyWxU8QuNkZ1Z+tqjCv4tcebTF+ov5PqeqEF5wCUS9CmaOdrQ2zyeHJ4wp4rjKZRlEV/mJbZu2ysSHqTaWbBdMLIp5lohbbMr7nnR4OTddpWnaKsuq0bI+MFR9KptJ3WPExIjZkm7mvDNg7PKULoV5DiKusVCMRnaFq1SLPReYcL3gDwkSnpd8oVd3dzaLuQDBOQJO0jMJvQ8IN+qHCPaxlxgDqklHDXSq0w4ApFL1iUKu09CNE4OXNSw59PchabvIfMOmlU4q5iUCubRn3SgMcL3jCRGcZ0K9F9W8rTYLjBTPSMnYVU2Zm7rHbzNulAf39H8OZrds+gMSAtA4lVxursi4nvGAUUF1AqHwhKL6siBs0hmQNhcWx0mGlRqRlbC8q7FrPUK8O5Hk7Zt4tADcKWx6/6cC/r7E/JKn88XcAAAAASUVORK5CYII=",
        "jpg": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAndJREFUOE+tlM9LVFEUx8/3vhlLQspIIoiKQHrvTamEtJH+gYoWBbUw5jlZSd7XtIsWhULugqKcN6KlvjeLCNq0MIhAilAoiwjC98Zc9A9YQpiWM3NPzODEjIw/SO/y3HM+93t+3APa5INN5hEc13/LQPVaYDCBwO+lZcq8r+P6IwzsJmZBwLhtGfG8HY7nP2XwfWIh8gahmJVAReU5xTPXY+Z03q8v5R/OMWqUYtY08VJG9R1LwGBAWsYVIobjBbeY0KIUd8dj5ru1VBfvHc//IS1zZxkw6aZjDL6kQI5gToR+z+/t6GieXw+0ItBJ+e2s6DyB+ojwGHNqv5SRuf8GLhW6h4SIsMol7LbIaCXYg2G/PqyJk1mhDcUv1P8sxFVKeT1KBgfTNQshngDRAhN9ti3j4oaACdd/RAK14YWq9uyWxU8QuNkZ1Z+tqjCv4tcebTF+ov5PqeqEF5wCUS9CmaOdrQ2zyeHJ4wp4rjKZRlEV/mJbZu2ysSHqTaWbBdMLIp5lohbbMr7nnR4OTddpWnaKsuq0bI+MFR9KptJ3WPExIjZkm7mvDNg7PKULoV5DiKusVCMRnaFq1SLPReYcL3gDwkSnpd8oVd3dzaLuQDBOQJO0jMJvQ8IN+qHCPaxlxgDqklHDXSq0w4ApFL1iUKu09CNE4OXNSw59PchabvIfMOmlU4q5iUCubRn3SgMcL3jCRGcZ0K9F9W8rTYLjBTPSMnYVU2Zm7rHbzNulAf39H8OZrds+gMSAtA4lVxursi4nvGAUUF1AqHwhKL6siBs0hmQNhcWx0mGlRqRlbC8q7FrPUK8O5Hk7Zt4tADcKWx6/6cC/r7E/JKn88XcAAAAASUVORK5CYII=",
        "jpeg": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAndJREFUOE+tlM9LVFEUx8/3vhlLQspIIoiKQHrvTamEtJH+gYoWBbUw5jlZSd7XtIsWhULugqKcN6KlvjeLCNq0MIhAilAoiwjC98Zc9A9YQpiWM3NPzODEjIw/SO/y3HM+93t+3APa5INN5hEc13/LQPVaYDCBwO+lZcq8r+P6IwzsJmZBwLhtGfG8HY7nP2XwfWIh8gahmJVAReU5xTPXY+Z03q8v5R/OMWqUYtY08VJG9R1LwGBAWsYVIobjBbeY0KIUd8dj5ru1VBfvHc//IS1zZxkw6aZjDL6kQI5gToR+z+/t6GieXw+0ItBJ+e2s6DyB+ojwGHNqv5SRuf8GLhW6h4SIsMol7LbIaCXYg2G/PqyJk1mhDcUv1P8sxFVKeT1KBgfTNQshngDRAhN9ti3j4oaACdd/RAK14YWq9uyWxU8QuNkZ1Z+tqjCv4tcebTF+ov5PqeqEF5wCUS9CmaOdrQ2zyeHJ4wp4rjKZRlEV/mJbZu2ysSHqTaWbBdMLIp5lohbbMr7nnR4OTddpWnaKsuq0bI+MFR9KptJ3WPExIjZkm7mvDNg7PKULoV5DiKusVCMRnaFq1SLPReYcL3gDwkSnpd8oVd3dzaLuQDBOQJO0jMJvQ8IN+qHCPaxlxgDqklHDXSq0w4ApFL1iUKu09CNE4OXNSw59PchabvIfMOmlU4q5iUCubRn3SgMcL3jCRGcZ0K9F9W8rTYLjBTPSMnYVU2Zm7rHbzNulAf39H8OZrds+gMSAtA4lVxursi4nvGAUUF1AqHwhKL6siBs0hmQNhcWx0mGlRqRlbC8q7FrPUK8O5Hk7Zt4tADcKWx6/6cC/r7E/JKn88XcAAAAASUVORK5CYII=",
        "pdf": "data:image/png;base64,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",
        "xls": "data:image/png;base64,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",
        "xlsx": "data:image/png;base64,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",
        "ppt": "data:image/png;base64,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",
        "pptx": "data:image/png;base64,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",
        "xml": "data:image/png;base64,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",
        "html": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAtCAYAAAA+7zKnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAHMmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNy4yLWMwMDAgNzkuMWI2NWE3OSwgMjAyMi8wNi8xMy0xNzo0NjoxNCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bXA6Q3JlYXRlRGF0ZT0iMjAyMy0wOS0wNlQxNDoyODo1NSswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMy0wOS0wNlQxNDoyODo1NSswODowMCIgeG1wOk1vZGlmeURhdGU9IjIwMjMtMDktMDZUMTQ6Mjg6NTUrMDg6MDAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjRlOWI4YmMtYTc3NC05YjRjLTg1NWEtOWM0ZWU1NzM2NTMyIiB4bXBNTTpEb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6ZjExNzJmOGUtZjRhNi1hYjRiLWI4NDgtNDBlODMyNTFiNzU5IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6ZWM1MzkzODQtOTQyMi0zMTRkLWIwZTMtNDI1MDdmZjQ0YzkwIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOmVjNTM5Mzg0LTk0MjItMzE0ZC1iMGUzLTQyNTA3ZmY0NGM5MCIgc3RFdnQ6d2hlbj0iMjAyMy0wOS0wNlQxNDoyODo1NSswODowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIzLjUgKFdpbmRvd3MpIiBzdEV2dDpjaGFuZ2VkPSIvIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJkZXJpdmVkIiBzdEV2dDpwYXJhbWV0ZXJzPSJjb252ZXJ0ZWQgZnJvbSBhcHBsaWNhdGlvbi92bmQuYWRvYmUucGhvdG9zaG9wIHRvIGltYWdlL3BuZyIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6NjRlOWI4YmMtYTc3NC05YjRjLTg1NWEtOWM0ZWU1NzM2NTMyIiBzdEV2dDp3aGVuPSIyMDIzLTA5LTA2VDE0OjI4OjU1KzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjMuNSAoV2luZG93cykiIHN0RXZ0OmNoYW5nZWQ9Ii8iLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmVjNTM5Mzg0LTk0MjItMzE0ZC1iMGUzLTQyNTA3ZmY0NGM5MCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDplYzUzOTM4NC05NDIyLTMxNGQtYjBlMy00MjUwN2ZmNDRjOTAiIHN0UmVmOm9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDplYzUzOTM4NC05NDIyLTMxNGQtYjBlMy00MjUwN2ZmNDRjOTAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7iPOuiAAAGDklEQVRo3tWZW2xUVRSGv3XOmUuHlrZQbkUk3KwQroom+OAFiQ8qiSYmBAUTjCZCjAnigzH65JMvxAcfTHzwxUK8JSTEKJGCt2gMolxEgilRyr20ltL7zJyzfFhnOtMyHabtgcpOJqf77LP3/tda//732ruiqtyuxQPg2+3DXivgAP6TSGZvxHMeQPXR6MDjF2nyFyHZvcA51N2OaKsZNaYiwAfAHcBakP2g6yICHxRpCt62IOg8IDuuWVRBSIJzEPQ9hCZUmmB8EXDML36RHwtB0ohkER0fcCsplDtADiBsQliLyP4IPC/F2vrzbTpe4BZeIR4O1RiGoxGRprGuAadEWzBuqow0pgoou1DdBKxFpClq8FEDL7KGaUR181gNcCYG+JDy8Vgj4EwccClca41jMcCJFvhI4DU3l19ihEZUnxuNAV40wIUSqpV7Hwf1ihhVWHaZCJWnQhF53gFioS/cIj8P4BRoQwnghQY8G0Zg/80Fr4QbsB8OlzPAGfpT7y2QGML7ZYy6G9VVwKOIfBl6JmLaaCEtcnTOebtwcxMsn8nuBF5D2ALyQwkHKmhzuC88jsg7wBsjgNcSfL0R8OEG5CIw3AgF2AH8ALxpCRreyItY1hrVWAwsL+F5Z3QpgJbceEKHBSGuHOcHnbMHZc8oFLUHqCrWYODVBcmU530tb8ahRgRjW14yOKNezyqvgPPlMEfHNvsgnVRG37VYZqjFFotGCXzE3ZRoRKJYLHVISqzjBz5ukDqYnuvIUrk01FMfJYtQBzgoy25qBloqJTcqu8BUlCUFm0gG+MMLT1KHQFaPEPFj/4OLgnsRTgyT5aOhN4PVt9/FR7DCK51Q5Qx1IdsHAx32abwaYpPB74f+NssoE7XgJaD3stVjKYjXgPrgeDDQCZluEIHkVHArrG+2F7wKSEyxb0chAuWlB5luqLoTZj1gk139C9JXwYlD/YM2efd56D5ndScGXS3QcwHiVZC+BpNmQtVc0AA6m2HgKtQuNkP626HrHzNyFKpU3iIM0uAPwOIXYNkrMPcJaDsCtQ2w/FVY8hIEWRDH6ku3wpIXIdtj7/v/hYUbYOk265+cCtf+hvlPwdKXYcEzZswoT2HlgU/UQttROPOl1Wc/bF6cdo/VWw/Bhe8NVA5A9QKoaYDuszB5HtStGHpwcVyjHdhTRi9m5fVQhYrp0PwFZHrATcDKHVC3ytqbPzOOiwy9dJhxP3S3mJHiDhNxMQpB/nlzDuBq3O27DM2fWL3+QUjUwNlvoOMkVEwLr2LckAIB1D8Eqdkwc40N03c5Ur0pP1aqBvbiT+Cn8+/PfGULtHChDXRA+zH7ft56qLkLOv6E/o4JAi9icjdnndEmV2Y/MtQYMApd+d3+bthsz0s/g5ecCPBiVKisN2UAOH/QnvPWQ+3d0Ncach5IToP24yaf8cnQ2wptxyBZV3z4bL/JbM9F6L1o68qJRXR7IJjcNTxvWtzZDL+9C9ULoXIOLNoAP/6SVxpxoOecqVDlbLhyyMDFUsXHr54Pq14HN2mg249a5OKTIwDf1w6z1sCdj4Ve/9a82rLP9Hz6fab9nc35Psk6OHcAUtPhbBMkp+QD7Xi2byRqwvvjGTD/6QLaVdjYkYB3PPNKy9fG+9ZfTf5aD0GsypTIqzAVOv25hcpLGQWO7LS+FdOh+VPzbH+HRaxlH1SeAD+Tp5wTM/VKzbwxIVQVvtumNwSf7rJtXAQqZhi4bK/Jn6p5NlZpmxJAapb1C3zbkALfjNHAgMUmQe8l47fI9aqWqIUgEwH4/2nJqc3J2xD7qRznV6K6bPAkBWlEPgzfrwn15tafpEAR+RE4ieqW8L7TBScD3vEc+DRweFjndsBHOMxE/a/W1kIG6ACO3kBt1DqIgGo1SCx/sevewpN4ePumgARxCCoHs48CR3rXd3JyGA8Aa8BfCe4RY1RwC5eiDwRLIEiAcxB1wvTJH3RiqDZbwwuhRGEUUkj6NAQzwd0N7oWRbmtvQsmAXw/+RnCuoLEFIF35dDoLuIWed4bdWTq9qLsC0Y9ANxr1brkY7kPjW8DtGkpZ8/5/QU44hgbCknoAAAAASUVORK5CYII=",
        "htm": "data:image/png;base64,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",
        "txt": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAtCAYAAAA+7zKnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAHMmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNy4yLWMwMDAgNzkuMWI2NWE3OSwgMjAyMi8wNi8xMy0xNzo0NjoxNCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bXA6Q3JlYXRlRGF0ZT0iMjAyMy0wOS0wNlQxNDoyODo1OCswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMy0wOS0wNlQxNDoyODo1OCswODowMCIgeG1wOk1vZGlmeURhdGU9IjIwMjMtMDktMDZUMTQ6Mjg6NTgrMDg6MDAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ZGNjZDg0NmQtOTZhZS1kNDRjLWJjZDAtZjc3YTllMjA4YjM3IiB4bXBNTTpEb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6M2MyODcwOGEtM2I5Ni0wMDQ1LTlmODgtNDFhMjU5ZmZmOGEzIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6NzA3NjQwOTAtZmU0YS1jZjRlLWIzM2YtMDcyZDVlYWI5NzExIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjcwNzY0MDkwLWZlNGEtY2Y0ZS1iMzNmLTA3MmQ1ZWFiOTcxMSIgc3RFdnQ6d2hlbj0iMjAyMy0wOS0wNlQxNDoyODo1OCswODowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIzLjUgKFdpbmRvd3MpIiBzdEV2dDpjaGFuZ2VkPSIvIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJkZXJpdmVkIiBzdEV2dDpwYXJhbWV0ZXJzPSJjb252ZXJ0ZWQgZnJvbSBhcHBsaWNhdGlvbi92bmQuYWRvYmUucGhvdG9zaG9wIHRvIGltYWdlL3BuZyIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6ZGNjZDg0NmQtOTZhZS1kNDRjLWJjZDAtZjc3YTllMjA4YjM3IiBzdEV2dDp3aGVuPSIyMDIzLTA5LTA2VDE0OjI4OjU4KzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjMuNSAoV2luZG93cykiIHN0RXZ0OmNoYW5nZWQ9Ii8iLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjcwNzY0MDkwLWZlNGEtY2Y0ZS1iMzNmLTA3MmQ1ZWFiOTcxMSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3MDc2NDA5MC1mZTRhLWNmNGUtYjMzZi0wNzJkNWVhYjk3MTEiIHN0UmVmOm9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3MDc2NDA5MC1mZTRhLWNmNGUtYjMzZi0wNzJkNWVhYjk3MTEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5A7aYuAAAF2klEQVRo3tWYz29UVRTHP+e+96a0pS0FIj9EFJFEUH4pidGVAVao0UQ3RFzwJ6gbY3Tl3hDjwgQTF9KyJUEWJhRiMMaEYEREAoIRQX6UX1JoO+3Mu8fFuW9mOp2Wdvoo8JKbmXffffd9zznf8+uKqvKoXjHArl/rZgXwIBGvS8z+PD+ocEhhS27giRo8iVgljv0IF9XzvkA/0jRgAb4SWCawGTiosDUX8NIAlDg+RcALK4CyzOAjHnAwBziMsMspfR76ZmoBB+Ci8UOEZ1BGRSmLzAy42GhTWKbKIYQdApsFDs4Y/ARXEUCCzZuhjK+7FSh4QJUeVd4V2OKg736A98yQKhNNqwnQ633FAn15g88beCWQafVPT+p5zzUpgJtN4A0lgT2pZ0czArgHDDyYgZ5UTYDp+ICbReAOSOtyic0q4OlJzYmnLECcC3CdkqYLQIzWiJINXxm9XsA5ehz0+XvkgTgvtYveI5w6TuN4IUu3WpN+a4VQT2/q0UjodcJBP0kmdrloPQJ1oB40Db/jxycoiQhfVoSs5X0mRAwasTcVNgJbBA4ASe6ar9Al03oUWO1r5sJzVQ5KxOcCH6DsBI4ED3C1RVAoVxQ4i+IdbPPwGfBRY/Bj7DgDno/ncFUIGx+qckSEjwU244nHOXH12qxwGmG1wLpGwSqucFamjn9CB9UJhEjHKGefCvvu1UZkLBIYVOgY91yDydJyKKAkp8hSx2GSQKlpWNcBkQOVym5jcaQ1nPehbnWTfMNPt+nSsWHB69TqO8mA2x7jSJ3tE9dS3of61TWgkJ9Jt6h1f3VqhqtHHQq6iUNlqpVsWcze9bPc5iqQ+iCA0aZYD7w+VD4PJAKp95SdsBBwXll7PyvQScoen3pwQgQsUGVNwBsBJeB3o03EURE2NXQc4beH4KDgRSecrKuLjrsg6qZH7txDWD/lDOsEyh4GShPztD02/xguW7ToTCAWuFuG4dQ4OSey+8n2aI3M93KrKkseCg7WdYeEpuOFu1aEuQm0xSbAP4PmafMKsLrVAsH1Ijzd0Tiri9jz/0YhcTmCHypDdxu89eTEa45chYFReO0Ju//6DJy4CW8/BSs74M8BOHp98j1+6ofvLsDi1hzBFxyMejh3x6ywaA50t5h5z981utwcgWPX4dUlZv5nu+DKsAHPhLtTgr/CHkvboCOBYgoXBiESuDps7+bajMyJTfu956C/CG8uh61L4fYofHsWSoEeCvxwBbYtgzXzoKtg7/9914TsSmDPObhZhB2rYNMC+HcQdp+B9gjaE9snV86rGq87Cwa0JapyvbMAZTXrdLfALzfMN5a1w/wWc/RDl02zibP1PqwHiJ0Bbo1sTTrFpOiaSSBS1zTV3rc44/3JW9XnF4fg7AB0F8ZWyEywxwM7+hhOTfsbF1TnlrTCirkWRSTHb+UK3gncGoGXFsJjrcbz07eNYlsfN4f3Dyv4obJx95VFdv9zv3EdTPPPzbOIJPIAwadqmRIMbFZ5DpbhjeX2zCucH7REda1oa95ZAXNjGCnbHllI7Eiaq1ybasA7E3PAkrdUL1KNGJeHjDqXhixCdSZw4CKs6rToMr/FtN+RwPGb0D8MN0ZM4OlaRFSVL/6YXvsdhXrlbslql+6WEC3EnHIkNZ7PK5hpB0pGKRGLOLGz9dl8tna62o+bpU1rZKO+y+lMqqcsPjQ2bbGN+q6sPa5SpxnaZJw/9ciVxMrpTB8bvGdt0FkKjDrH7jD/csgfs9ZJhYrTAxpF/KjKKe/ZCRSACKGE50QGfhQ4lpW5kTnPDVVS5zjm/axrtYIjtHy3RDg+WQ8LYi+E04MulETTZg7fZw5eIjv3RCiIY64486laRbr6DEnWuSuHgEgjNqBAORBqlkZw9jUILQqHfdkObBuFSpOoPMYKbS7hHMJi9ewl5RLS+LT2Pmi+hGOpxGzHc82XWYlyp+IP4WRs7EGrjjlzH9KI9RLxjTi2z6K71mL43pfYiQ/A685G/gfDj34egOC6fgAAAABJRU5ErkJggg==",
        "doc": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAtCAYAAAA+7zKnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAHMmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNy4yLWMwMDAgNzkuMWI2NWE3OSwgMjAyMi8wNi8xMy0xNzo0NjoxNCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bXA6Q3JlYXRlRGF0ZT0iMjAyMy0wOS0wNlQxNDoyODo1OSswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMy0wOS0wNlQxNDoyODo1OSswODowMCIgeG1wOk1vZGlmeURhdGU9IjIwMjMtMDktMDZUMTQ6Mjg6NTkrMDg6MDAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTkyMTI5YzgtOWU0NC1mYTQyLTk0NDEtMzlhYTc2ZmZlZmZkIiB4bXBNTTpEb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6ZWQ5YzZmMTAtZDYxNS02MjQwLWEwNTctY2FiNjVjYjM0NjhkIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6MTc5YzA3ZjItNzJmOC0wZTQ2LTg3NzUtNGU4ZDcyYjc1NjA0IiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjE3OWMwN2YyLTcyZjgtMGU0Ni04Nzc1LTRlOGQ3MmI3NTYwNCIgc3RFdnQ6d2hlbj0iMjAyMy0wOS0wNlQxNDoyODo1OSswODowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIzLjUgKFdpbmRvd3MpIiBzdEV2dDpjaGFuZ2VkPSIvIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJkZXJpdmVkIiBzdEV2dDpwYXJhbWV0ZXJzPSJjb252ZXJ0ZWQgZnJvbSBhcHBsaWNhdGlvbi92bmQuYWRvYmUucGhvdG9zaG9wIHRvIGltYWdlL3BuZyIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6MTkyMTI5YzgtOWU0NC1mYTQyLTk0NDEtMzlhYTc2ZmZlZmZkIiBzdEV2dDp3aGVuPSIyMDIzLTA5LTA2VDE0OjI4OjU5KzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgMjMuNSAoV2luZG93cykiIHN0RXZ0OmNoYW5nZWQ9Ii8iLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjE3OWMwN2YyLTcyZjgtMGU0Ni04Nzc1LTRlOGQ3MmI3NTYwNCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxNzljMDdmMi03MmY4LTBlNDYtODc3NS00ZThkNzJiNzU2MDQiIHN0UmVmOm9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxNzljMDdmMi03MmY4LTBlNDYtODc3NS00ZThkNzJiNzU2MDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4kf8GGAAAGp0lEQVRo3tWZa2wUVRTHf3dmH6XttqVSqAQUokVBhUrQSKIhFozBV6KCBgET1BgTYwz6QWP0gzFqfAbU+H7EaKkmmmCMJj5ARREVUBQUG8A0AuXRli1st9vdnZnjhzu7Oy3b7Wx3wXCTm529c/fe/zn3fx73rBIRTtUWAKhfdfwLR7+8Jqj4tMx7rkeYXzbwRp4XJjS5wPfZwkqlOKxGv48CXgUmAS0ovkZYcMLAG/AIgAhTHbDMUnYRQFEh8I3AKgPWoVhX6gkYAAF1fFeKswVSorAMVSJwrfpKYJII64Fl2RMoFbzk6cCA98xLAe4xo5C7fivCUmA+inUlgR+mOYWxFAV80Jqug1uDZE9gXbnBF4GpuEme021FWD5aAYzS2VAccDXIhgF4f7QnYJSHzsXzSgbzsnU0AgRK94CuBsWXouwCU1sRBEWrXzdaEvisBsXXEYdcL4y3D2lrXI34EsCgDM1xVeoU6ALtCs7JbFrA/a5BuMVPHCgdvOjjy3DCyiOIDVjCw0BQKV7ycVBtCBe6ceAzIFh+2kjuw3AXs90uQzyLwNcCzyu4D8UK4PsCChRgtyv7VaJ4DHgwL3hVbAAaxupMtzt5hHD3uF9p0A8BLR5587UWoB2YDswcVvNOsSmAFB423G56qOT5yVpgrd9rhFLEgUi+vQJoPhJUpQEvJISRL9fwB3xIQM4FOku8fJPyAM+XBpgZi5NsXuMXeH5WSx5jKbiwlGbX4nefIhR4nKV7Fh7ITv0frrkeHJJNz2V4V3m+e7q2CJZSjAMMhAvKGdCKiX0ioBQmcBrCDBevCaSBHUpEaFzNZgVzTqXKgcDvhqvSUwq4i3lWwA+lAyZ0xSGZ8Ni/AZExEAlpfmbdo4KUDd19QModDMG4agiZuSROuR6lux9SiVytZWwEKoNgOyPbra/0IJaA5gnQVK8XtRzoScBvh6CzGxrqIWiAYcDBGFg2XNmkfyMC2w7Bl7shFITx1eA4kLahKwrTJkJLM9SG4Z9e+KQdBtJQXzmyAL7AH+2F5ZfD3UPItesIPPszvP4zNIyFvhhUBeC9RXBt0+C5H/0Nt66FaByqKjTwu+bCUy1QE87N+7MLFn0MHb1QN6YcNykDEpZ+7B2AD7bD3j59Eq8thOWzoasLEilouyEHvHUHfPiXfl50LrxzHcT74XA3LJ4FryzUwHf2wGuboD8NU+sgngLTR8QP+Pdb+nNPFJa8C1TBt7fDvDPg2QXw3maYcwYsPEvPe/JHeOhDTe6DS+Hei+DmGfD4ZNjeAc9doedt7oRL3gYnCqv/AFvgcBwaqjU9y5rPVwSgcgIQg1W/6LHxlVBXD9Pq9feUDS9vBRqAenhxc074aWNhXANMrtHfn/kJnBhMnAq7o5oufoCXls9HtNFm2tgQVIf0c08CEmnNbduBfgtiSaitgHAAxnu4vC8GVINjw2nuuOX4dpejzPYSUBPyGHUakmlXkAoYE9ReI5mGMQGocucm0lqYTKsJA0kwTYil4EgCTOMEgR+wIN6pHe2ds10jTsKRKOw5mqPW9eeAvQ/kACyeDgF3p129sL835wbvaNbg93dAVRDOrIXDfbn5ZaFNxvgbq+GRa2B+E8ybrMee2KizjY0dsOUAzDkdnl8AkaAG8eg8Pe+7f2HHfh28XtgCKy/WXqjtNtjQDvdcqj3YnLegvRvqKkfAJCKcvrpwkD14CN68CW5vPv7d05vgga+gPgLH4jCxBj5fAuc1DJ7360G4ug2iCagIQd8AtN2oT8XbbIEFrbChA8ZHygC+LwGXTYFLJ2tPgoLOmHZz2/ZCbQSqw3p8f1QHl2UzYXajjrBbD8C7f2j/PalOU64nrvl/4wyYPwUiYdjZrWPD3qPQWKMjccnggwE4cAysuIc/BqgwTKjS+UzGFZqGDmTx2ODyQaRGG2eG66ah7afnqJvXuHfFUCU0VGngI+VcvsCPPiHPJWAj3rREK6EYG8zY9M4TkraqkYFngRT5D4YD7ZmUuFnpG1PQrVakULwBNCPMHSLoSbtJAYLiB2Anwgp0vdN0IG3B9oyrTAFbh/y4B7BRbEVK+GunlKZAIC0QBX5Xhfy8AkRln2sFgpYL3OLkCZAplyhtByEF1SjXfiQPeJWr5uJqer1SzDWh2YZt6ZMM3i1WzTAg7MA3tuRKimqIt0EEkp4Kj4LKsGKPgkYH2izoVMNUa08A+LQJEwOwxIGupHCWzmM1vkyBM+DVurdm6UC/JcwKKt5RsCT0P1DegS+SwgobYobHijOF2/8AsByIl8ZVcTYAAAAASUVORK5CYII=",
        "docx": "data:image/png;base64,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",
      }
    }
  },
  mounted() {
    //是移动端返回true,否则false
    this.hasH5 = this.isMobile()
    if (this.hasH5) {
      this.activeLabDoc = 'is-active'
      this.elUploadMdjy = "new-el-upload-mdjy-h5";
      this.showupload = 'new-el-upload-manjy-h5'
    } else {
      this.activeLabDoc = 'active-lab'
      this.showupload = 'new-el-upload-manjy'
      this.elUploadMdjy = "new-el-upload-mdjy";

    }
    // 注册 VueClipboard 插件
    Vue.use(VueClipboard);
    this.checkUploadCountByDay1();
    // this.timer = setInterval(function () {
    //   let x = document.getElementsByClassName("el-progress__text");
    //   let count = 0;
    //   for (let i = 0; i < x.length; i++) {
    //     if (x[i].innerHTML === "100%") {
    //       count = count + 1;
    //       console.log(x[i])
    //       x[i].parentNode.previousSibling.previousSibling.previousSibling.style.display = "block";
    //     }
    //   }
    //   if (x.length !== 0 && count === x.length) {
    //     clearInterval(that.timer);
    //     setTimeout(function () {
    //       if (that.hasH5) {
    //         that.showUploadOk = false;
    //         that.showExcelUploadOk = false;
    //         that.getPower()
    //         return
    //       }
    //       that.dialogTableVisible = true;
    //     }, 1500);
    //   }
    // }, 10);
    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleClickOutside);
  },
  watch: {
    domain(val) {
      if (val !== '') {
        this.terminology = '暂不使用术语'
        if ((val === 'novel' || val === 'wiki')) {
          this.uploadform.from = 'zh'
          this.uploadform.to = 'en'
          return;
        }
        if ((this.uploadform.from === 'zh' || this.uploadform.from === 'en') && (this.uploadform.to === 'zh' || this.uploadform.to === 'en')) {
          return;
        }
        this.uploadform.from = 'zh'
        this.uploadform.to = 'en'
      }
    },
    terminology(val) {
      if (val !== '暂不使用术语') {
        if ((this.uploadform.from === 'zh' || this.uploadform.from === 'en') && (this.uploadform.to === 'zh' || this.uploadform.to === 'en')) {
          this.domain = ''
          return;
        }
        this.uploadform.from = 'zh'
        this.uploadform.to = 'en'
        this.domain = ''
      }
    },
    dialogTableVisible(val) {
      if (!val) {
        this.$refs.fileUpload.clearFiles();
        this.$refs.fileUpload.$data.uploadFiles = [];
        this.idData = [];
        this.gridData = [];
        this.orderMoney = 0;
        this.moneys = 0;
        this.pages = 0;
        this.isUploadDisabled = false;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy";
        }
        this.$router.push("/list");
      } else {
        let request = parentPowerRequest;
        request.setMoney(this.moneys)
        const TOKEN_KEY = "token";
        translateServiceClient.checkParentPower(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          this.isShowMoney = res.getShowmoney();
          if (this.isShowMoney && this.moneys === 0) {
            this.isShowFree = true;
          }
        }).catch(err => {
          this.isShowMoney = true;
        })
      }
    },
    originaltext(val) {
      if (this.lastTime === 0) {
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      } else {
        clearTimeout(this.lastTime)
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      }
    },
    "uploadform.from": function (val) {
      this.originalFrom = this.getChineseName(val)
      if (this.lastTime === 0) {
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      } else {
        clearTimeout(this.lastTime)
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      }
    },
    "uploadform.to": function (val) {
      this.originalTo = this.getChineseName(val);
      if (this.lastTime === 0) {
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      } else {
        clearTimeout(this.lastTime)
        this.lastTime = setTimeout(() => {
          this.submitTransText()
        }, 2000)
      }
    },
    "uploadImgForm.from": function (val) {
      this.originalImgFrom = this.getImgChineseName(val)
    },
    "uploadImgForm.to": function (val) {
      this.originalImgTo = this.getImgChineseName(val);
    },
    checkType(val) {
      if (val === 'setting') {
        this.selectMedicineDictSpec()
        this.handleCurrentChange(1)
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.isRoamingTimer);
    clearTimeout(this.isRoamingTimerOut);
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleClickOutside);
  },
  beforeCreate() {
    const that = this;
    window.addEventListener('message', function (e) {
      if (e.data.data === "params") {
        that.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
      }
      if (e.data.data === "register") {
        that.openTry()
      }
      if (e.data.data === "close") {
        layer.closeAll()
      }
      if (e.data.data === "topHidden") {
        that.showHeader = false
      }
      if (e.data.data === "topNotHidden") {
        that.showHeader = true
      }
    })
    const TOKEN_KEY = 'token';
    authServiceClient.getUserStatus(userStatusRequest, {
      [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
    }).then(res => {
      if (!res.getStatus()) {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.groupUserInfo = "";
        this.showRoaming = false;
        return;
      }
      const user = localStorage.getItem('auth-context');
      if (!user) {
        return
      }
      const userJson = JSON.parse(user);
      const Base64 = require('js-base64').Base64;
      userJson.forEach(item => {
        if (item.type === 'Person' || item.type === 'Child') {
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          if (item.type === 'Person') {
            this.userType = '0'
          }
          if (item.type === 'Child') {
            this.userType = '1'
          }
          this.userInfo = realName
          this.userId = item.name;
          if (!item.isRoaming) {
            let roaming = localStorage.getItem(this.userId)
            if (!roaming || roaming !== '1') {
              this.showRoaming = true
            } else {
              this.showRoaming = false
              this.userType = '2'
            }
          } else {
            this.userType = '2'
          }
          if (this.groupUserInfo === '') {
            this.groupUserInfo = '机构登录';
          }
          this.showloginOut = true
        }
        if (item.type === 'Group') {
          this.groupUserInfos.push(item)
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          this.groupUserInfo = realName;
          this.url = process.env.VUE_APP_WEB_LOGIN_URL;
        }
      })
    }).catch(err => {
      localStorage.removeItem("token")
      localStorage.removeItem("auth-context")
      this.userInfo = "";
      this.showRoaming = false;
    });
  },
  created() {
    let query = this.$route.query;
    this.checkType = query?.type || 'txt'
    this.getUploadTip();
  },
  methods: {
    aiSend() {
      if (this.session === '') {
        return
      }
      let request = aiSendRequest;
      request.setSessionId(this.session.getSessionId())
      request.setContent(this.message)
      this.aiMessageTemp = {"content": this.message, "messageType": "question"};
      this.message = ''
      const TOKEN_KEY = "token"
      translateServiceClient.aiSend(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.getHistory(this.session, true);
        return
      }).catch(err => {
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
          } else {
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          }
          return
        }
        this.$message.error("服务暂不可用，请稍后再试")
      })
    },
    getHistory(session, flag) {

      this.session = session
      let request = aiHistoryPageRequest
      request.setSessionId(session.getSessionId())
      request.setSize(10)
      request.setIsUseCursor(false)
      if (flag && this.aiMessage.length > 0) {
        request.setSize(2)
      } else {
        this.aiMessage = []
      }
      const TOKEN_KEY = "token"
      translateServiceClient.aiHistoryPage(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.aiMessage.push(...res.getMessageList());
        this.aiMessageTemp = {}
        if (this.aiMessage) {
          this.createAi = true
          return
        }
        this.$message.error("获取失败，请稍后再试")
      }).catch(err => {
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
          } else {
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          }
          return
        }
        this.$message.error("服务暂不可用，请稍后再试")
      })
    },
    callBack() {
      this.aiSessionPage()
      this.createAi = false
    },
    createAiSession() {
      let request = createAiSessionRequest;
      const TOKEN_KEY = "token";
      translateServiceClient.createAiSession(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        let session = res.getSession();
        if (session) {
          this.session = session
          this.createAi = true
          return
        }
        this.$message.error("删除失败，请稍后再试")
      }).catch(err => {
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
          } else {
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          }
          return
        }
        this.$message.error("服务暂不可用，请稍后再试")
      })
    },
    delAiSession(sessionId) {
      console.log(sessionId)
      let request = delAiSessionRequest;
      request.setSessionId(sessionId)
      const TOKEN_KEY = "token";
      translateServiceClient.delAiSession(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        if (res.getStatus()) {
          this.aiSessionPage()
          return
        }
        this.$message.error("删除失败，请稍后再试")
      }).catch(err => {
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
          } else {
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          }
          return
        }
        this.$message.error("服务暂不可用，请稍后再试")
      })
    },
    aiSessionPage() {
      let request = aiSessionPageRequest
      request.setPageSize(20)
      request.setPageNum(1)
      const TOKEN_KEY = "token";
      translateServiceClient.aiSessionPage(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.sessionList = res.getSessionList();
        this.showAi = true
      }).catch(err => {
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
          } else {
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          }
          return
        }
        this.$message.error("服务暂不可用，请稍后再试")
      })
    },
    selectMedicineDictSpec() {
      const request = selectMedicineDictSpecRequest
      const TOKEN_KEY = "token";
      translateServiceClient.selectMedicineDictSpec(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.specData = res.getSpecList();
      }).catch(err => {
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
          } else {
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          }
          return
        }
        this.$message.error("获取临床专业名词失败，请稍后再试")
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      const request = getMedicineDictRequest;
      request.setCurrentPage(this.currentPage)
      request.setPageSize(this.pageSize)
      request.setSpec(this.specQuery)
      request.setWord(this.query)
      let loadingInstance = Loading.service({fullscreen: true, text: '获取医学术语中...', customClass: 'loadClass'});
      const TOKEN_KEY = "token";
      translateServiceClient.getMedicineDict(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        loadingInstance.close()
        this.queryCount = res.getCount();
        this.queryData = res.getMedicineDictList()
      }).catch(err => {
        if (err.code === 5) {
          loadingInstance.close()
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
          } else {
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          }
          return
        }
        this.$message.error("获取医学术语失败，请稍后再试")
        loadingInstance.close()
      })
    },
    copyText() {
      if (this.translatetext !== undefined && this.translatetext !== null && this.translatetext !== '' && this.translatetext !== '翻译失败，请重试。') {
        // 调用 $copyText 方法复制文本
        this.$copyText(this.translatetext);
        this.$message.success('复制成功');
      }
    },
    copySettingText(txt) {
      this.$copyText(txt);
      this.$message.success('复制成功');
    },
    openNewMessage() {
      this.$alert('服务升级中，敬请期待', '产品升级', {
        confirmButtonText: '确定',
      });
    },
    changeDomain(item) {
      if (item.domain !== '') {
        item.terminology = '暂不使用术语'
        if ((item.domain === 'novel' || item.domain === 'wiki')) {
          item.from = 'zh'
          item.to = 'en'
          return;
        }
        if ((item.from === 'zh' || item.from === 'en') && (item.to === 'zh' || item.to === 'en')) {
          return;
        }
        item.from = 'zh'
        item.to = 'en'
      }
    },
    changeTerminology(item) {
      if (item.terminology !== '暂不使用术语') {
        if ((item.from === 'zh' || item.from === 'en') && (item.to === 'zh' || item.to === 'en')) {
          item.domain = ''
          return;
        }
        item.from = 'zh'
        item.to = 'en'
        item.domain = ''
      }
    },
    tmpList(tmpType) {
      const TOKEN_KEY = "token";
      let request = selectTmpRequest;
      request.setTmpType(tmpType)
      translateServiceClient.selectTmp(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        if (res.getStatus()) {
          this.tmpFileData = []
          res.getUploadtmpfilesList().forEach(item => {
            const data = {}
            data['id'] = item.getId()
            data['type'] = item.getType()
            data['title'] = item.getTitle()
            data['page'] = item.getPage()
            data['character'] = item.getCharacter()
            data['from'] = item.getFrom()
            data['to'] = item.getTo()
            data['domain'] = item.getDomain()
            data['terminology'] = item.getTerminology() === undefined || item.getTerminology() === null || item.getTerminology() === '' ? "暂不使用术语" : item.getTerminology()
            this.tmpFileData.push(data);
          })
          return
        }
        this.$message.error(res.getMessage());
      }).catch(err => {
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return;
          }
          this.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        } else {
          this.$message.error("查询失败，请稍后再试！");
        }
      })
    },
    handleClickOutside(event) {
      // 判断点击事件的目标是否在指定的 div 元素之内
      if (!this.$refs.divToExclude1.contains(event.target) &&
          !this.$refs.divToExclude2.contains(event.target) &&
          !this.$refs.divToExclude3.contains(event.target) &&
          !this.$refs.divToExclude4.contains(event.target) &&
          !this.$refs.divToExclude5.contains(event.target) &&
          !this.$refs.divToExclude6.contains(event.target) &&
          !this.$refs.divToExclude7.contains(event.target) &&
          !this.$refs.divToExclude8.contains(event.target) &&
          !this.$refs.divToExclude9.contains(event.target) &&
          !this.$refs.divToExclude10.contains(event.target) &&
          !this.$refs.divToExclude11.contains(event.target) &&
          !this.$refs.divToExclude12.contains(event.target) &&
          !this.$refs.divToExclude13.contains(event.target) &&
          !this.$refs.divToExclude14.contains(event.target) &&
          !this.$refs.divToExclude15.contains(event.target) &&
          !this.$refs.divToExclude16.contains(event.target)) {
        this.showLangV = -1
      }
    },
    getDomainName(value) {
      for (let i = 0; i < this.domainOptions.length; i++) {
        const item = this.domainOptions[i];
        if (item.value === value) {
          return item.label;
        }
      }
      return '通用领域'; // 如果没有找到匹配的选项，则返回默认值
    },
    showLang(v) {
      if (this.showLangV === v) {
        this.showLangV = -1
        return
      }
      this.showLangV = v
    },
    setHasSendMail(val) {
      if (val) {
        let loadingInstance = Loading.service({fullscreen: true, text: '获取邮箱中...', customClass: 'loadClass'});
        const TOKEN_KEY = "token";
        translateServiceClient.getEmail(getEmailRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {

          let mail = res.getMail();
          if (mail === null || mail === '' || mail === undefined) {
            this.hasSendMail = false
            this.setMailVisible = true
            loadingInstance.close()
            return
          }
          this.email = mail
          this.hasSendMail = val
          loadingInstance.close()
        }).catch(err => {
          if (err.code === 5) {
            this.email = '';
            this.hasSendMail = false
            loadingInstance.close()
            localStorage.removeItem("token");
            localStorage.removeItem("auth-context");
            if (this.hasH5) {
              this.$router.push("/h5/login");
            } else {
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            }
            return
          }
          this.email = '';
          this.hasSendMail = false
          this.$message.error("获取邮箱失败，请稍后再试")
          loadingInstance.close()
        })
        return;
      }
      this.email = '';
      this.hasSendMail = val
    },
    toSetMail() {
      window.open("https://user.wesitrans.com/account", '_blank')
    },
    getPower() {
      let request = parentPowerRequest;
      request.setMoney(this.moneys)
      const TOKEN_KEY = "token";
      translateServiceClient.checkParentPower(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.isShowMoney = res.getShowmoney();
        if (this.isShowMoney && this.moneys === 0) {
          this.isShowFree = true;
        }
      }).catch(err => {
        this.isShowMoney = true;
      })
    },
    isMobile() {
      return window.matchMedia('(max-width: 768px)').matches
    },
    toCenter() {
      window.open("https://user.wesitrans.com/account", '_blank')
    },
    getQrcode() {
      this.qrcodeUrl = "http://common.wesitrans.com/common/roaming/qrcode"
      this.isRoamingTimer = setInterval(this.roamingEvent, 1000)
      this.isRoamingTimerOut = setTimeout(this.clearTime, 60000);
    },
    clearTime() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    roamingEvent() {
      if (this.userId && localStorage.getItem(this.userId) !== '1') {
        let request = checkRoamingRequest
        request.setUserId(this.userId)
        const TOKEN_KEY = "token";
        translateServiceClient.checkRoaming(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        }).then(res => {
          localStorage.setItem(this.userId, res.getMessage())
          if (res.getMessage() === '1') {
            window.location.reload()
          }
        }).catch(err => {
        })
      }
    },
    removeQrcode() {
      this.qrcodeUrl = "";
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    openRecommendations() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      } else {
        layer.open({
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no'],
        });
      }
    },
    logOut(val) {
      if (val === "toCenter") {
        window.open("http://user.wesitrans.com", '_blank')
        return;
      }
      if (val === "toAccount") {
        window.open("https://user.wesitrans.com/account", '_blank')
        return;
      }
      if (val === "toOrder") {
        window.open("https://user.wesitrans.com/order", '_blank')
        return;
      }
      if (val === "txtTrans") {
        this.checkType = 'txt'
        return;
      }
      if (val === "docTrans") {
        this.checkType = 'doc'
        return;
      }
      if (val === "mediaTrans") {
        this.openNewMessage()
        return;
      }
      if (val === "imgTrans") {
        this.checkType = 'img'
        return;
      }
      if (val === "xlsTrans") {
        this.checkType = 'more'
        return;
      }
      if (val === "musicTrans") {
        this.openNewMessage()
        return;
      }

      if (val === "toTransPro") {
        this.toPath('/trans-pro')
        return;
      }
      if (val === "standLangSet") {
        this.toPath('/translate', 'setting')
        return;
      }
      if (val === "convertDoc") {
        this.checkType = 'convert'
        return;
      }
      if (val === "imgTrans") {
        this.openNewMessage()
        return;
      }
      if (val === "mySelfDoc") {
        this.toPath('/list-pro')
        return;
      }
      if (val === "webTranslate") {
        this.toPath('/translate', 'plugin')
        return;
      }
      if (val === "smartClassify") {
        this.toPath('/smart-classify')
        return;
      }
      let request = outRequest;
      if (val === undefined) {
        request.setName(this.userInfo)
      } else {
        request.setName(val)
      }
      const TOKEN_KEY = 'token';
      authServiceClient.logOut(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        window.location.reload();
        this.$router.push("/index")
      }).catch(err => {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.showRoaming = false;
        this.$router.push("/index")
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
      });
    },
    showIframe(url) {
      return this.$authPopup.open(url)
    },
    toPath(url, type) {
      if (url === '/trans-pro') {
        window.open("/trans-pro/index", "_self")
        return;
      }
      if (url === '/list' || url === '/list-pro') {
        const TOKEN_KEY = 'token';
        authServiceClient.getUserStatus(userStatusRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
        }).then(res => {
          if (!res.getStatus()) {
            localStorage.removeItem("token")
            localStorage.removeItem("auth-context")
            if (this.hasH5) {
              this.$router.push("/h5/login");
              return;
            }
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            return;
          }
          if (localStorage.getItem('auth-context') &&
              localStorage.getItem('token')) {
            authServiceClient.checkUserPower(userPowerRequest, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
            }).then(res => {
              if (res.getStatus()) {
                if (type) {
                  this.$router.push({
                    path: url,
                    query: {type: type}
                  });
                  return;
                }
                this.$router.push(url)
                return;
              }
              this.$message({
                center: true,
                type: 'error',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            }).catch(err => {
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            })
          }
        }).catch(err => {
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return;
          }
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        });
        return
      }
      if (type) {
        this.$router.push({
          path: url,
          query: {type: type}
        });
        return;
      }
      this.$router.push(url);
    },
    getUploadTip() {
      const TOKEN_KEY = "token";
      translateServiceClient.getUploadTip(uploadTipRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.isShowTransPro = res.getIsTransPro();
        this.isShowInRoaming = res.getIsRoaming();
        this.title = res.getMessage();
        if (this.title === undefined || this.title === null || this.title === '') {
          this.selectOption = "selectOption1"
        }
      }).catch(err => {
        this.isShowInRoaming = false;
        this.isShowTransPro = true;
        this.title = '';
        this.selectOption = "selectOption1"
      });
    },
    submitTransText() {
      if (!this.originaltext) {
        return
      }
      const text = this.originaltext.replace(/\s+/g, "");
      if (text === null || text === "") {
        return
      }
      if (this.uploadform.from === this.uploadform.to) {
        this.translatetext = this.originaltext
        return
      }
      this.translatetext = "正在翻译...";
      let request = transTextRequest;
      request.setText(this.originaltext)
      request.setFrom(this.uploadform.from)
      request.setTo(this.uploadform.to)
      translateServiceClient.submitTransText(request).then(res => {
        this.translatetext = res.getText()
      }).catch(err => {
        this.translatetext = "翻译失败，请重试。"
      })
    },
    leaveTab(activeName, oldActiveName) {
    },
    getUserStatus() {
      const that = this;
      const TOKEN_KEY = "token";
      authServiceClient
          .getUserStatus(userStatusRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          }).then((res) => {
        if (!res.getStatus()) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return false;
          }
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          return false;
        }
        const user = localStorage.getItem("auth-context");
        if (!user) {
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return false;
          }
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
          return false;
        }
        return that.checkUserPower();
      }).catch((err) => {
        localStorage.removeItem("token");
        localStorage.removeItem("auth-context");
        if (this.hasH5) {
          this.$router.push("/h5/login");
          return false;
        }
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        return false;
      });

    },
    checkUserPower() {
      const that = this;
      const TOKEN_KEY = "token";
      authServiceClient.checkUserPower(userPowerRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      })
          .then(res => {
            if (!res.getStatus()) {
              that.$message({
                center: true,
                type: 'error',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return false;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
              return false;
            }
            return that.checkUploadCountByDay();
          }).catch(err => {
        if (this.hasH5) {
          this.$router.push("/h5/login");
          return false;
        }
        this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        return false;
      })
    },
    checkUploadCountByDay() {
      const that = this;
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              that.$message.error(res.getMessage());
              that.isUploadDisabled = true;
              if (that.hasH5) {
                that.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                that.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              that.limitCount = res.getLimitcount();
              return false;
            }
            that.isUploadDisabled = false;
            if (that.hasH5) {
              that.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              that.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              that.count = 10;
              that.limitCount = res.getLimitcount();
              return true;
            }
            that.count = res.getCount();
            that.limitCount = res.getLimitcount();
            return true;
          })
          .catch(err => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return false;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            } else {
              that.$message.error("文件上传遇到了问题，请稍后再试！");
            }
            return false;
          })
    },
    checkUploadCountByDay1() {
      const that = this;
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              that.$message.error(res.getMessage());
              that.isUploadDisabled = true;
              that.isImgUploadDisabled = true;
              that.isExcelUploadDisabled = true;
              if (that.hasH5) {
                that.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                that.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              that.limitCount = res.getLimitcount();
              return false;
            }
            that.isUploadDisabled = false;
            that.isImgUploadDisabled = false;
            that.isExcelUploadDisabled = false;
            if (that.hasH5) {
              that.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              that.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              that.count = 10;
              that.limitCount = res.getLimitcount();
              return true;
            }
            that.count = res.getCount();
            that.limitCount = res.getLimitcount();
            return true;
          })
          .catch(err => {
            return false;
          })
    },
    clickShowDoc(target) {
      if (target === "0") {
        this.showTxt = false
        this.showImg = false
        this.showExcel = false
        this.showDoc = true
        if (this.hasH5) {
          this.activeLabDoc = 'is-active'
        } else {
          this.activeLabDoc = 'active-lab'
        }
        this.activeLabTxt = ''
        this.activeLabImg = ''
        this.activeLabExcel = ''
      }
      if (target === "1") {
        this.showTxt = true
        this.showDoc = false
        this.showImg = false
        this.showExcel = false
        this.activeLabDoc = ''
        this.activeLabImg = ''
        this.activeLabExcel = ''
        if (this.hasH5) {
          this.activeLabTxt = 'is-active'
        } else {
          this.activeLabTxt = 'active-lab'
        }
      }
      if (target === "2") {
        this.showTxt = false
        this.showDoc = false
        this.showExcel = false
        this.showImg = true
        this.activeLabDoc = ''
        this.activeLabTxt = ''
        this.activeLabExcel = ''
        if (this.hasH5) {
          this.activeLabImg = 'is-active'
        } else {
          this.activeLabImg = 'active-lab'
        }
      }
      if (target === "3") {
        this.showTxt = false
        this.showDoc = false
        this.showImg = false
        this.showExcel = true
        this.activeLabDoc = ''
        this.activeLabTxt = ''
        this.activeLabImg = ''
        if (this.hasH5) {
          this.activeLabExcel = 'is-active'
        } else {
          this.activeLabExcel = 'active-lab'
        }
      }
    },
    submitConvertPay() {

      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id)
      })
      let request = submitConvertRequest;
      request.setIdsList(ids).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient.submitConvert(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          if (res.getMessage() !== undefined && res.getMessage() !== null && res.getMessage() !== "") {
            window.open(res.getMessage(), "_self");
            return;
          }
          this.$router.push(
              {
                path: '/list',
                query: {
                  type: "convert"
                }
              }
          )
          return
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "提交失败请稍后再试"
        });
      })
    },
    submitPay() {
      if (this.gridData && this.gridData[0] && this.gridData[0].tmpType && this.gridData[0].tmpType === 'convert') {
        this.submitConvertPay()
        return
      }
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id)
      })
      let request = submitRequest;
      request.setIdsList(ids).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient.submit(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        if (res.getStatus()) {
          if (res.getMessage() !== undefined && res.getMessage() !== null && res.getMessage() !== "") {
            window.open(res.getMessage(), "_self");
            return;
          }
          this.$router.push("/list");
          return
        }
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: res.getMessage()
        });
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "提交失败请稍后再试"
        });
      })
    },
    closeTip() {
      this.selectOption = "selectOption1"
    },
    yuwenClose1(event) {
      this.showUpload1 = !event;
      if (this.showUpload1 && this.showUpload2) {
        if (this.hasH5) {
          this.showupload = 'new-el-upload-manjy-h5'
        } else {
          this.showupload = 'new-el-upload-manjy'
        }
        this.isShowupload = true;
        this.languages = "languages";
      } else {
        this.showupload = 'new-el-upload-manjy-display'
        this.isShowupload = false;
        this.languages = "openlanguages";
      }
      if (this.uploadform.from) {
        this.originalFrom = this.getChineseName(this.uploadform.from)
        this.one = true;
        this.two = false;
        this.three = false;
        this.four = false;
      }
    },
    yuwenClose2(event) {
      this.showUpload2 = !event;
      if (this.showUpload1 && this.showUpload2) {
        if (this.hasH5) {
          this.showupload = 'new-el-upload-manjy-h5'
        } else {
          this.showupload = 'new-el-upload-manjy'
        }
        this.isShowupload = true;
        this.languages2 = "languages";
      } else {
        this.showupload = 'new-el-upload-manjy-display'
        this.isShowupload = false;
        this.languages2 = "openlanguages";
      }
      if (this.uploadform.to) {
        this.originalTo = this.getChineseName(this.uploadform.to)
        this.one2 = true;
        this.two2 = false;
        this.three2 = false;
      }
    },
    onSuccess() {
      return false;
    },
    doSomething(e) {
      document.location.href = 'https://wesitrans.com/wesitrans/template/表格翻译样例.xlsx'
      try {
        e.stopPropagation();//非IE浏览器
      } catch (e) {
        window.event.cancelBubble = true;//IE浏览器
      }
    },
    handleRemove(file) {
      this.$refs.fileUpload.abort(); //取消上传
      this.$refs.fileUploadImg.abort();
      this.$refs.fileUploadExcel.abort();
      this.$refs.fileConvertUpload.abort();
      this.$refs.fileUploadExcel.abort();

    },
    onError(err, file, fileList) {
    },
    changeLanuage2(event) {
      if (
          (event.target.innerText === "中文(简体)" && this.one2) ||
          (event.target.innerText === "英语" && this.two2) ||
          (event.target.innerText === "日语" && this.three2)
      ) {
        this.one2 = false;
        this.two2 = false;
        this.three2 = false;
        this.uploadform.to = "zh";
        return;
      }
      this.one2 = false;
      this.two2 = false;
      this.three2 = false;
      if (event.target.innerText === "中文(简体)") {
        this.uploadform.to = "zh";
        this.one2 = true;
        return;
      }
      if (event.target.innerText === "英语") {
        this.uploadform.to = "en";
        this.two2 = true;
        return;
      }
      if (event.target.innerText === "日语") {
        this.uploadform.to = "ja";
        this.three2 = true;
        return;
      }
      this.one2 = true;
    },
    zhuanhuanItem(item) {
      if (item.from === "auto") {
        this.$message.error("请选择原文件语言");
        return
      }
      if (item.domain === 'novel' || item.domain === 'wiki') {
        this.$message.error(item.domain === 'novel' ? "网络文学领域暂时只支持 中文（简）-> 英语" : "人文社科领域暂时只支持 中文（简）-> 英语");
        return
      }
      const tmp = item.from;
      item.from = item.to;
      item.to = tmp;
    },
    zhuanhuanImgItem(item) {
      if (item.from === "auto") {
        this.$message.error("请选择原文件语言");
        return
      }
      const tmp = item.from;
      item.from = item.to;
      item.to = tmp;
    },
    zhuanhuanImg() {
      if (this.uploadImgForm.from === "auto") {
        this.$message.error("请选择原文件语言");
        return
      }
      const tmp = this.uploadImgForm.from;
      this.uploadImgForm.from = this.uploadImgForm.to;
      this.uploadImgForm.to = tmp;
    },
    zhuanhuan() {
      if (this.uploadform.from === "auto") {
        this.$message.error("请选择原文件语言");
        return
      }
      if (this.domain === 'novel' || this.domain === 'wiki') {
        this.$message.error(this.domain === 'novel' ? "网络文学领域暂时只支持 中文（简）-> 英语" : "人文社科领域暂时只支持 中文（简）-> 英语");
        return
      }
      if (this.uploadform.from !== "zh" && this.uploadform.from !== "en" && this.uploadform.from !== "ja") {
        this.originalTo = this.getChineseName(this.uploadform.from)
        this.one2 = true;
        this.two2 = false;
        this.three2 = false;
      }
      if (this.uploadform.to !== "zh" && this.uploadform.to !== "en" && this.uploadform.to !== "ja") {
        this.originalFrom = this.getChineseName(this.uploadform.to);
        this.one = true;
        this.two = false;
        this.three = false;
        this.four = false;
      }
      if (this.uploadform.from === "zh") {
        this.one2 = true;
        this.two2 = false;
        this.three2 = false;
      }
      if (this.uploadform.from === "en") {
        this.one2 = false;
        this.two2 = true;
        this.three2 = false;
      }
      if (this.uploadform.from === "ja") {
        this.one2 = false;
        this.two2 = false;
        this.three2 = true;
      }
      if (this.uploadform.to === "zh") {
        this.one = false;
        this.two = true;
        this.three = false;
        this.four = false;
      }
      if (this.uploadform.to === "en") {
        this.one = false;
        this.two = false;
        this.three = true;
        this.four = false;
      }
      if (this.uploadform.to === "ja") {
        this.one = false;
        this.two = false;
        this.three = false;
        this.four = true;
      }
      const tmp = this.uploadform.from;
      this.uploadform.from = this.uploadform.to;
      this.uploadform.to = tmp;
    },
    changeLanuage(event) {
      this.one = false;
      this.two = false;
      this.three = false;
      this.four = false;
      if (event.target.innerText === "自动检测") {
        this.uploadform.from = "auto";
        this.one = true;
        return;
      }
      if (event.target.innerText === "中文(简体)") {
        this.uploadform.from = "zh";
        this.two = true;
        return;
      }
      if (event.target.innerText === "英语") {
        this.uploadform.from = "en";
        this.three = true;
        return;
      }
      if (event.target.innerText === "日语") {
        this.uploadform.from = "ja";
        this.four = true;
        return;
      }
      this.one = true;
    },
    getChineseName(lanuage) {
      let label = lanuage;
      languages.forEach((item) => {
        if (item.value === lanuage) {
          label = item.label;
        }
      });
      return label;
    },
    getImgChineseName(lanuage) {
      let label = lanuage;
      this.imgFromOptions.forEach((item) => {
        if (item.value === lanuage) {
          label = item.label;
        }
      });
      return label;
    },
    submitTmpTrans(flag, tmpType) {
      if (!flag && this.checkTmpList.length === 0) {
        this.$confirm('您确认要翻译全部文件吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.checkTmpList = this.tmpFileData.map(item => item.id)
          this.submitTmpTrans(true, tmpType)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '勾选您要翻译的文档吧'
          });
        });
        return
      }
      const checkList = this.tmpFileData.filter(item => this.checkTmpList.indexOf(item.id) >= 0)
      if (checkList.length === 0) {
        this.$message.warning("请勾选您要翻译的文档");
        return
      }
      const transTmpFiles = []
      debugger
      checkList.forEach(check => {
        let data = new TransTmpFile()
        data.setId(check.id)
        data.setFrom(check.from)
        data.setTo(check.to)
        data.setDomain(check.domain)
        data.setTerminology(check.terminology)
        transTmpFiles.push(data)
      })
      console.log(checkList)
      console.log(transTmpFiles)
      let request = transTmpRequest
      request.setTranstmpfilesList(transTmpFiles)
      request.setTmpType(tmpType)
      const TOKEN_KEY = "token";
      translateServiceClient.transTmp(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        if (res.getStatus()) {
          let uploadfileList = res.getUploadfileList();
          uploadfileList.forEach(file => {
            const data = {};
            data.id = file.getId();
            data.title = file.getTitle();
            data.page = file.getPage();
            data.money = file.getOrderMoney();
            this.gridData.push(data);
            this.moneys = this.moneys + file.getMoney();
            this.orderMoney = this.orderMoney + file.getOrderMoney();
            this.pages = this.pages + file.getPage();
          })
          this.dialogTableVisible = true
          return
        }
        this.$message.error(res.getMessage());
      }).catch(err => {
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return;
          }
          this.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        } else {
          this.$message.error("翻译失败，请稍后再试！");
        }
      })
    },
    submitTmpConvertTrans(flag, tmpType) {
      if (!flag && this.checkTmpList.length === 0) {
        this.$confirm('您确认要转换全部文件吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.checkTmpList = this.tmpFileData.map(item => item.id)
          this.submitTmpConvertTrans(true, tmpType)
        }).catch(() => {
          this.$message({
            type: 'warning',
            message: '勾选您要转换的文档吧'
          });
        });
        return
      }

      const checkList = this.tmpFileData.filter(item => this.checkTmpList.indexOf(item.id) >= 0)
      if (checkList.length === 0) {
        this.$message.warning("请勾选您要转换的文档");
        return
      }
      const transTmpFiles = []
      checkList.forEach(check => {
        let data = new TransTmpFile()
        data.setId(check.id)
        transTmpFiles.push(data)
      })
      let request = transTmpRequest
      request.setTranstmpfilesList(transTmpFiles)
      request.setTmpType(tmpType)
      const TOKEN_KEY = "token";
      translateServiceClient.transTmp(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        if (res.getStatus()) {
          let uploadfileList = res.getUploadfileList();
          uploadfileList.forEach(file => {
            const data = {};
            data.id = file.getId();
            data.title = file.getTitle();
            data.page = file.getPage();
            data.money = file.getOrderMoney();
            data.tmpType = tmpType
            this.gridData.push(data);
            this.moneys = this.moneys + file.getMoney();
            this.orderMoney = this.orderMoney + file.getOrderMoney();
            this.pages = this.pages + file.getPage();
          })
          this.dialogTableVisible = true
          return
        }
        this.$message.error(res.getMessage());
      }).catch(err => {
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return;
          }
          this.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        } else {
          this.$message.error("翻译失败，请稍后再试！");
        }
      })
    },
    delTmp(id, tmpType) {
      const TOKEN_KEY = "token";
      let request = delTmpRequest;
      request.setId(id)
      request.setTmpType(tmpType)
      translateServiceClient.delTmp(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        if (res.getStatus()) {
          this.tmpFileData = []
          res.getUploadtmpfilesList().forEach(item => {
            const data = {}
            data['id'] = item.getId()
            data['type'] = item.getType()
            data['title'] = item.getTitle()
            data['page'] = item.getPage()
            data['character'] = item.getCharacter()
            data['from'] = item.getFrom()
            data['to'] = item.getTo()
            data['domain'] = item.getDomain()
            data['terminology'] = item.getTerminology() === undefined || item.getTerminology() === null || item.getTerminology() === '' ? "暂不使用术语" : item.getTerminology()
            this.tmpFileData.push(data);
          })
          if (this.tmpFileData.length === 0) {
            this.isShowNewUpload = true;
            this.isShowNewUploadList = false;
          }
          return
        }
        this.$message.error(res.getMessage());
      }).catch(err => {
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return;
          }
          this.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        } else {
          this.$message.error("删除失败，请稍后再试！");
        }
      })
    },
    submitUploadConvertTmpFiles(tmpType) {
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              return
            }
            this.isShowNewUpload = false;
            this.isUploadDisabled = false;
            if (res.getCount() >= 10) {
              this.count = 10
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            const files = this.$refs.fileConvertUpload.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            //上传进度
            this.timer = setInterval(() => {
              if (this.processNum === 100) {
                this.processNum = 1
              }
              if (this.processNum < 99) {
                this.processNum += 1
              } else {
                clearInterval(this.timer)
              }
            }, 10)
            let request = uploadTmpRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            reader.onloadend = () => {
              request.setTmpType(tmpType)
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              translateServiceClient.uploadTmp(request, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
                  .then((res) => {
                    if (res.getStatus()) {
                      this.tmpFileData = []
                      res.getUploadtmpfilesList().forEach(item => {
                        const data = {}
                        data['id'] = item.getId()
                        data['type'] = item.getType()
                        data['title'] = item.getTitle()
                        data['page'] = item.getPage()
                        data['character'] = item.getCharacter()
                        this.tmpFileData.push(data);
                      })
                      this.isShowNewUploadList = true;
                      return;
                    }
                    this.$refs.fileConvertUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileConvertUpload.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: 'error',
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage()
                    });
                    if (files.length === 0) {
                      clearInterval(this.timer)
                      this.processNum = 100;
                      this.isShowNewUpload = true;
                      this.isUploadDisabled = false;
                    }
                  })
                  .catch((error) => {

                    this.isShowNewUpload = true;
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
                      return;
                    }
                    this.$refs.fileConvertUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileConvertUpload.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                    }
                  });
            };
          })
          .catch(err => {
            this.isShowNewUpload = true;
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          })
    },
    submitUploadImgTmpFiles(tmpType) {
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              return
            }
            this.isShowNewUpload = false;
            this.isUploadDisabled = false;
            if (res.getCount() >= 10) {
              this.count = 10
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            if (this.uploadImgForm.from === "原文语言") {
              this.uploadImgForm.from = "auto";
            }
            if (this.uploadImgForm.to === "目标语言") {
              this.uploadImgForm.to = "zh";
            }
            const files = this.$refs.fileUploadImg.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            //上传进度
            this.timer = setInterval(() => {
              if (this.processNum === 100) {
                this.processNum = 1
              }
              if (this.processNum < 99) {
                this.processNum += 1
              } else {
                clearInterval(this.timer)
              }
            }, 10)
            let request = uploadTmpRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            reader.onloadend = () => {
              request.setTmpType(tmpType)
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setFrom(this.uploadImgForm.from);
              request.setTo(this.uploadImgForm.to);
              translateServiceClient.uploadTmp(request, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
                  .then((res) => {
                    if (res.getStatus()) {
                      this.tmpFileData = []
                      res.getUploadtmpfilesList().forEach(item => {
                        const data = {}
                        data['id'] = item.getId()
                        data['type'] = item.getType()
                        data['title'] = item.getTitle()
                        data['page'] = item.getPage()
                        data['character'] = item.getCharacter()
                        data['from'] = item.getFrom()
                        data['to'] = item.getTo()
                        data['domain'] = item.getDomain()
                        data['terminology'] = item.getTerminology() === undefined || item.getTerminology() === null || item.getTerminology() === '' ? "暂不使用术语" : item.getTerminology()
                        this.tmpFileData.push(data);
                      })
                      this.isShowNewUploadList = true;
                      return;
                    }
                    this.$refs.fileUploadImg.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadImg.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: 'error',
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage()
                    });
                    if (files.length === 0) {
                      clearInterval(this.timer)
                      this.processNum = 100;
                      this.isShowNewUpload = true;
                      this.isUploadDisabled = false;
                    }
                  })
                  .catch((error) => {

                    this.isShowNewUpload = true;
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
                      return;
                    }
                    this.$refs.fileUploadImg.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadImg.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                    }
                  });
            };
          })
          .catch(err => {
            this.isShowNewUpload = true;
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          })
    },
    submitUploadMoreTmpFiles(tmpType) {
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              return
            }
            this.isShowNewUpload = false;
            this.isUploadDisabled = false;
            if (res.getCount() >= 10) {
              this.count = 10
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            const files = this.$refs.fileUploadExcel.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            //上传进度
            this.timer = setInterval(() => {
              if (this.processNum === 100) {
                this.processNum = 1
              }
              if (this.processNum < 99) {
                this.processNum += 1
              } else {
                clearInterval(this.timer)
              }
            }, 10)
            let request = uploadTmpRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            reader.onloadend = () => {
              request.setTmpType(tmpType)
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              translateServiceClient.uploadTmp(request, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
                  .then((res) => {
                    if (res.getStatus()) {
                      this.tmpFileData = []
                      res.getUploadtmpfilesList().forEach(item => {
                        const data = {}
                        data['id'] = item.getId()
                        data['type'] = item.getType()
                        data['title'] = item.getTitle()
                        data['character'] = item.getCharacter()
                        this.tmpFileData.push(data);
                      })
                      this.isShowNewUploadList = true;
                      return;
                    }
                    this.$refs.fileUploadExcel.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadExcel.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: 'error',
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage()
                    });
                    if (files.length === 0) {
                      clearInterval(this.timer)
                      this.processNum = 100;
                      this.isShowNewUpload = true;
                      this.isUploadDisabled = false;
                    }
                  })
                  .catch((error) => {

                    this.isShowNewUpload = true;
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
                      return;
                    }
                    this.$refs.fileUploadExcel.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadExcel.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                    }
                  });
            };
          })
          .catch(err => {
            this.isShowNewUpload = true;
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          })
    },
    submitUploadTmpFiles(tmpType) {
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              return
            }
            this.isShowNewUpload = false;
            this.isUploadDisabled = false;
            if (res.getCount() >= 10) {
              this.count = 10
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            //上传进度
            let unm = 0;
            if (this.uploadform.from === "原文语言") {
              this.uploadform.from = "auto";
            }
            if (this.uploadform.to === "目标语言") {
              this.uploadform.to = "zh";
            }
            const files = this.$refs.fileUpload.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            this.timer = setInterval(() => {
              if (this.processNum === 100) {
                this.processNum = 1
              }
              if (this.processNum < 99) {
                this.processNum += 1
              } else {
                clearInterval(this.timer)
              }
            }, 10)
            let request = uploadTmpRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            reader.onloadend = () => {
              request.setTmpType(tmpType)
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setFrom(this.uploadform.from);
              request.setTo(this.uploadform.to);
              request.setDomain(this.domain)
              request.setTerminology(this.terminology)
              translateServiceClient.uploadTmp(request, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
                  .then((res) => {

                    if (res.getStatus()) {
                      this.tmpFileData = []
                      res.getUploadtmpfilesList().forEach(item => {
                        const data = {}
                        data['id'] = item.getId()
                        data['type'] = item.getType()
                        data['title'] = item.getTitle()
                        data['page'] = item.getPage()
                        data['character'] = item.getCharacter()
                        data['from'] = item.getFrom()
                        data['to'] = item.getTo()
                        data['domain'] = item.getDomain()
                        data['terminology'] = item.getTerminology() === undefined || item.getTerminology() === null || item.getTerminology() === '' ? "暂不使用术语" : item.getTerminology()
                        this.tmpFileData.push(data);
                      })
                      this.isShowNewUploadList = true;
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: 'error',
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage()
                    });
                    if (files.length === 0) {
                      clearInterval(this.timer)
                      this.processNum = 100;
                      this.isShowNewUpload = true;
                      this.isUploadDisabled = false;
                    }
                  })
                  .catch((error) => {

                    this.isShowNewUpload = true;
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                    }
                  });
            };
          })
          .catch(err => {
            this.isShowNewUpload = true;
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          })
    },
    submitUploadFiles(event) {
      let time
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              if (this.hasH5) {
                this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                this.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              return
            }
            this.isShowupload = false;
            this.isUploadDisabled = false;
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              this.count = 10
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-display-h5"
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy-display";
            }
            //上传进度
            let unm = 0;
            event.onProgress({percent: unm});
            time = setInterval(function () {
              let Range = 5 - 1;
              let Rand = Math.random();
              unm = 1 + Math.round(Rand * Range) + unm;
              if (unm > 99) {
                unm = 99;
              }
              event.onProgress({percent: unm});
            }, 100);
            if (this.uploadform.from === "原文语言") {
              this.uploadform.from = "auto";
            }
            if (this.uploadform.to === "目标语言") {
              this.uploadform.to = "zh";
            }
            const files = this.$refs.fileUpload.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            let request = uploadRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            const thatEvent = event;
            reader.onloadend = () => {
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setFrom(this.uploadform.from);
              request.setTo(this.uploadform.to);
              request.setSendMail(this.hasSendMail)
              translateServiceClient
                  .upload(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    clearInterval(time);
                    if (res.getStatus()) {
                      thatEvent.onProgress({percent: 100})
                      const file = res.getUploadfile();
                      const data = {};
                      data.id = file.getId();
                      data.title = file.getTitle();
                      data.page = file.getPage();
                      data.money = file.getOrderMoney();
                      this.gridData.push(data);
                      this.moneys = this.moneys + file.getMoney();
                      this.orderMoney = this.orderMoney + file.getOrderMoney();
                      this.pages = this.pages + file.getPage();
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: 'error',
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage()
                    });
                    if (files.length === 0) {
                      this.isShowupload = true;
                      this.isUploadDisabled = false;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  })
                  .catch((error) => {

                    this.isShowupload = true;
                    clearInterval(time);
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  });
            };
          }).catch(err => {
        this.isShowupload = true;
        clearInterval(time);
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return;
          }
          this.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        } else {
          this.$message.error("文件上传遇到了问题，请稍后再试！");
        }
      })
    },
    submitExcelUploadFiles(event) {

      let time
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
          .then(res => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isExcelUploadDisabled = true;
              if (this.hasH5) {
                this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                this.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              return
            }
            this.isShowupload = false;
            this.isUploadDisabled = false;
            this.isExcelUploadDisabled = false;
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              this.count = 10
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-display-h5"
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy-display";
            }
            //上传进度
            let unm = 0;
            event.onProgress({percent: unm});
            time = setInterval(function () {
              let Range = 5 - 1;
              let Rand = Math.random();
              unm = 1 + Math.round(Rand * Range) + unm;
              if (unm > 99) {
                unm = 99;
              }
              event.onProgress({percent: unm});
            }, 100);
            if (this.uploadform.from === "原文语言") {
              this.uploadform.from = "auto";
            }
            if (this.uploadform.to === "目标语言") {
              this.uploadform.to = "zh";
            }
            const files = this.$refs.fileUploadExcel.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            let request = uploadRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            const thatEvent = event;
            reader.onloadend = () => {
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setFrom(this.uploadform.from);
              request.setTo(this.uploadform.to);
              request.setFlag(1)
              translateServiceClient
                  .upload(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    clearInterval(time);
                    if (res.getStatus()) {
                      thatEvent.onProgress({percent: 100})
                      const file = res.getUploadfile();
                      const data = {};
                      data.id = file.getId();
                      data.title = file.getTitle();
                      data.page = file.getPage();
                      data.money = file.getOrderMoney();
                      this.gridData.push(data);
                      this.moneys = this.moneys + file.getMoney();
                      this.orderMoney = this.orderMoney + file.getOrderMoney();
                      this.pages = this.pages + file.getPage();
                      return;
                    }
                    this.$refs.fileUploadExcel.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadExcel.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: 'error',
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage()
                    });
                    if (files.length === 0) {
                      this.isExcelUploadDisabled = false;
                      this.isShowupload = true;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  })
                  .catch((error) => {
                    this.isShowupload = true;
                    clearInterval(time);
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
                      return;
                    }
                    this.$refs.fileUploadExcel.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadExcel.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isExcelUploadDisabled = false;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  });
            };
          }).catch(err => {
        this.isShowupload = true;
        clearInterval(time);
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return;
          }
          this.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        } else {
          this.$message.error("文件上传遇到了问题，请稍后再试！");
        }
      })
    },
    submitImgUploadFiles(event) {
      const TOKEN_KEY = "token";
      translateServiceClient.checkUploadCountByDay(uploadCountRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        if (!res.getIsoverstepcount()) {
          this.$message.error(res.getMessage());
          this.isImgUploadDisabled = true;
          if (this.hasH5) {
            this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
          } else {
            this.elUploadMdjy = "new-el-upload-mdjy-none";
          }
          return
        }
        this.isShowupload = false;
        this.isImgUploadDisabled = false;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy";
        }
        if (res.getCount() >= 10) {
          this.count = 10
          this.limitCount = res.getLimitcount();
        } else {
          this.count = res.getCount();
          this.limitCount = res.getLimitcount();
        }
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-display-h5"
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-display";
        }
        //上传进度
        let unm = 0;
        event.onProgress({percent: unm});
        let time = setInterval(function () {
          let Range = 5 - 1;
          let Rand = Math.random();
          unm = 1 + Math.round(Rand * Range) + unm;
          if (unm > 99) {
            unm = 99;
          }
          event.onProgress({percent: unm});
        }, 100);
        if (this.uploadform.from === "原文语言") {
          this.uploadform.from = "auto";
        }
        if (this.uploadform.to === "目标语言") {
          this.uploadform.to = "zh";
        }
        const files = this.$refs.fileUploadImg.$data.uploadFiles;
        const file = files[this.uploadCount];
        this.uploadCount = ++this.uploadCount;
        let request = uploadRequest;
        let reader = new FileReader();
        reader.readAsArrayBuffer(file.raw, "utf-8");
        const thatEvent = event;
        reader.onloadend = () => {
          request.setFile(new Uint8Array(reader.result));
          request.setName(file.name);
          request.setSize(file.size);
          request.setFrom(this.uploadform.from);
          request.setTo(this.uploadform.to);
          translateServiceClient
              .uploadImg(request, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
              .then((res) => {
                clearInterval(time);
                if (res.getStatus()) {
                  thatEvent.onProgress({percent: 100})
                  const file = res.getUploadfile();
                  const data = {};
                  data.id = file.getId();
                  data.title = file.getTitle();
                  data.page = file.getPage();
                  data.money = file.getOrderMoney();
                  this.gridData.push(data);
                  this.moneys = this.moneys + file.getMoney();
                  this.orderMoney = this.orderMoney + file.getOrderMoney();
                  this.pages = this.pages + file.getPage();
                  return;
                }
                this.$refs.fileUploadImg.clearFiles();
                this.uploadCount = --this.uploadCount;
                files.splice(this.uploadCount, 1);
                this.$refs.fileUploadImg.$data.uploadFiles = files;
                this.$message({
                  center: true,
                  type: 'error',
                  showClose: true,
                  duration: 6000,
                  message: res.getMessage()
                });
                if (files.length === 0) {
                  this.isShowupload = true;
                  this.isImgUploadDisabled = false;
                  if (this.hasH5) {
                    this.elUploadMdjy = "new-el-upload-mdjy-h5";
                  } else {
                    this.elUploadMdjy = "new-el-upload-mdjy";
                  }
                }
              })
              .catch((error) => {
                this.isShowupload = true;
                clearInterval(time);
                if (error && error.code === 5) {
                  localStorage.removeItem("token");
                  localStorage.removeItem("auth-context");
                  if (this.hasH5) {
                    this.$router.push("/h5/login");
                    return;
                  }
                  this.$router.push("/index");
                  this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
                  return;
                }
                this.$refs.fileUploadImg.clearFiles();
                this.uploadCount = --this.uploadCount;
                files.splice(this.uploadCount, 1);
                this.$refs.fileUploadImg.$data.uploadFiles = files;
                this.$message.error("上传文件失败");
                if (files.length === 0) {
                  this.isImgUploadDisabled = false;
                  if (this.hasH5) {
                    this.elUploadMdjy = "new-el-upload-mdjy-h5";
                  } else {
                    this.elUploadMdjy = "new-el-upload-mdjy";
                  }
                }
              });
        };
      }).catch(err => {
        this.isShowupload = true;
        clearInterval(time);
        if (err.code === 5) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return;
          }
          this.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
        } else {
          this.$message.error("文件上传遇到了问题，请稍后再试！");
        }
      })
    },
    onExceed() {
      if (this.count === 10) {
        this.$message.error("仅支持批量上传10个文件！");
        this.isUploadDisabled = false;
        return;
      }
      if (this.count === 0) {
        this.$message.error("当前账户仅支持24小时内上传" + this.limitCount + "篇文献")
        this.isUploadDisabled = true;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";
        }
        return;
      }
      this.$message({
        center: true,
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: "<span style='font-size:14px;font-family: Microsoft YaHei;font-weight: 400;color: #EF6C6C;'>当前账户仅支持24小时内上传" + this.limitCount + "篇文献，您还剩余&nbsp;<span style='font-size:20px;'>" + this.count + "</span>&nbsp;篇</span>"
      });
      if (this.hasH5) {
        this.elUploadMdjy = "new-el-upload-mdjy-h5";
      } else {
        this.elUploadMdjy = "new-el-upload-mdjy";
      }
      this.isUploadDisabled = false;
    },
    onImgExceed() {
      if (this.count === 10) {
        this.$message.error("仅支持批量上传10张图片！");
        this.isImgUploadDisabled = false;
        return;
      }
      if (this.count === 0) {
        this.$message.error("当前账户仅支持24小时内上传" + this.limitCount + "张图片")
        this.isImgUploadDisabled = true;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";
        }
        return;
      }
      this.$message({
        center: true,
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: "<span style='font-size:14px;font-family: Microsoft YaHei;font-weight: 400;color: #EF6C6C;'>当前账户仅支持24小时内上传" + this.limitCount + "张图片，您还剩余&nbsp;<span style='font-size:20px;'>" + this.count + "</span>&nbsp;张</span>"
      });
      if (this.hasH5) {
        this.elUploadMdjy = "new-el-upload-mdjy-h5";
      } else {
        this.elUploadMdjy = "new-el-upload-mdjy";
      }
      this.isImgUploadDisabled = false;
    },
    beforeImgUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      const extension =
          testmsg === "jpg" ||
          testmsg === "jpeg" ||
          testmsg === "png";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "图片类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的图片内容为空！");
        return false;
      }
      const islimit = file.size < 4194304;
      if (!islimit) {
        this.$message.error("图片上传大小不能超过4M！");
      }
      return extension && islimit;
    },
    onExcelExceed() {
      if (this.count === 10) {
        this.$message.error("仅支持批量上传10个文件！");
        this.isExcelUploadDisabled = false;
        return;
      }
      if (this.count === 0) {
        this.$message.error("当前账户仅支持24小时内上传" + this.limitCount + "篇文献")
        this.isExcelUploadDisabled = true;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";
        }
        return;
      }
      this.$message({
        center: true,
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: "<span style='font-size:14px;font-family: Microsoft YaHei;font-weight: 400;color: #EF6C6C;'>当前账户仅支持24小时内上传" + this.limitCount + "篇文献，您还剩余&nbsp;<span style='font-size:20px;'>" + this.count + "</span>&nbsp;篇</span>"
      });
      if (this.hasH5) {
        this.elUploadMdjy = "new-el-upload-mdjy-h5";
      } else {
        this.elUploadMdjy = "new-el-upload-mdjy";
      }
      this.isExcelUploadDisabled = false;
    },
    beforeExcelUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      const extension =
          testmsg === "xls" ||
          testmsg === "xlsx";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "文件类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的文件内容为空！");
        return false;
      }
      const islimit = file.size < 2097152000;
      if (!islimit) {
        this.$message.error("文件上传大小不能超过20M！");
      }
      let isSuccess = extension && islimit
      if (isSuccess) {
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";

        }
      }
      return isSuccess;
    },
    beforeConvertUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      const extension = testmsg === "pdf";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "文件类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的文件内容为空！");
        return false;
      }
      const islimit = file.size < 2097152000;
      if (!islimit) {
        this.$message.error("文件上传大小不能超过20M！");
      }
      let isSuccess = extension && islimit
      if (isSuccess) {
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";

        }
      }
      return isSuccess;
    },
    beforeUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      const extension =
          testmsg === "xml" ||
          testmsg === "html" ||
          testmsg === "htm" ||
          testmsg === "xls" ||
          testmsg === "xlsx" ||
          testmsg === "pdf" ||
          testmsg === "ppt" ||
          testmsg === "pptx" ||
          testmsg === "doc" ||
          testmsg === "docx" ||
          testmsg === "txt";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "文件类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的文件内容为空！");
        return false;
      }
      const islimit = file.size < 2097152000;
      if (!islimit) {
        this.$message.error("文件上传大小不能超过20M！");
      }
      let isSuccess = extension && islimit
      if (isSuccess) {
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";

        }
      }
      return isSuccess;
    },
  }
}
</script>


<style lang="less" scoped src="../assets/v2/css/trans/common.less"/>
<style lang="less" scoped src="../assets/v2/css/trans/index.less"/>

<style lang="less">
.loader {
  float: inline-end;
  border: 2px solid #f3f3f3; /* Light grey */
  border-top: 2px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes breathing-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes shaking-animation {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px) rotate(-5deg);
  }
  50% {
    transform: translateX(5px) rotate(5deg);
  }
  75% {
    transform: translateX(-5px) rotate(-5deg);
  }
  100% {
    transform: translateX(0);
  }
}

.breathing {
  animation: breathing-animation 3s ease-in-out infinite, shaking-animation 1s linear infinite;
}

.el-upload-list {
  display: none;
}

.loadClass {
  .el-loading-spinner .path {
    stroke: var(--primary-dark);
  }

  .el-loading-spinner .el-loading-text {
    color: var(--primary-dark);
  }
}

.hasSendMailClass {
  .el-checkbox__input {
    width: 17px;
    height: 17px;
    background: #fff;
    border: 1px solid #CCCCCC;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-checkbox__inner {
    border: 0px solid #DCDFE6;
    position: relative;
    border-radius: 0px;
    box-sizing: border-box;
    width: 11px;
    height: 11px;
    background-color: #FFF;
    z-index: 1;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: var(--primary-dark);
    width: 11px;
    height: 11px;
    background: var(--primary-dark);
  }

  .el-checkbox__inner::after {
    display: none;
  }
}

.hasSendMailClassH5 {
  .el-checkbox__input {
    width: 24px;
    height: 24px;
    background: #fff;
    border: 1px solid #CCCCCC;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-checkbox__inner {
    border: 0px solid #DCDFE6;
    position: relative;
    border-radius: 0px;
    box-sizing: border-box;
    width: 11px;
    height: 11px;
    background-color: #FFF;
    z-index: 1;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: var(--primary-dark);
    width: 11px;
    height: 11px;
    background: var(--primary-dark);
  }

  .el-checkbox__inner::after {
    display: none;
  }
}

.triangle {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 590px;
  height: 45px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
  border-radius: 6px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  text-align: center;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  border: 0px solid #999999;
}

.triangle:before {
  position: absolute;
  content: "";
  top: -10px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 12px solid #99999991;
}

/* 白色覆盖*/
.triangle:after {
  position: absolute;
  content: "";
  /*减少两像素*/
  top: -8px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #ffffff;
}

.user-img {
  width: 16px;
  float: right;
  padding-left: 5px;
}

.selectOption {
  width: 1200px !important;
  top: 368px !important;
  left: 50% !important;
  transform: translate(-50%, 0px);

  .el-scrollbar {
    height: 577px !important;
  }

  .el-select-group__title {
    padding-left: 20px !important;
    font-size: 24px !important;
    color: #999999 !important;
    line-height: 60px !important;
  }

  .el-select-group .el-select-dropdown__item {
    padding-left: 20px;
    width: 14% !important;
  }

  .el-select-dropdown {
    width: 1200px !important;
    height: 720px !important;
  }

  .el-select-dropdown__wrap {
    max-height: 720px !important;
  }

  .popper__arrow {
    display: none !important;
  }

  .el-select-dropdown__item {
    float: left !important;
  }

  .el-select-group__wrap:not(:last-of-type) {
    width: 100% !important;
  }

  .el-select-group__wrap {
    float: left !important;
    width: 100% !important;
  }

}

.selectOption1 {
  width: 1200px !important;
  top: 368px !important;
  left: 50% !important;
  transform: translate(-50%, 0px);

  .el-scrollbar {
    height: 577px !important;
  }

  .el-select-group__title {
    padding-left: 20px !important;
    font-size: 24px !important;
    color: #999999 !important;
    line-height: 60px !important;
  }

  .el-select-group .el-select-dropdown__item {
    padding-left: 20px;
    width: 14% !important;
  }

  .el-select-dropdown {
    width: 1200px !important;
    height: 720px !important;
  }

  .el-select-dropdown__wrap {
    max-height: 720px !important;
  }

  .popper__arrow {
    display: none !important;
  }

  .el-select-dropdown__item {
    float: left !important;
  }

  .el-select-group__wrap:not(:last-of-type) {
    width: 100% !important;
  }

  .el-select-group__wrap {
    float: left !important;
    width: 100% !important;
  }

}

.selectOption .el-scrollbar__thumb {
  width: 8px !important;
}

.selectOption1 .el-scrollbar__thumb {
  width: 8px !important;
}

</style>

<style lang="less" scoped>
@media (max-width: 768px) {
  .page,
  .group_1,
  .box_1 {
    width: 100%;
    min-width: 0 !important;
    min-height: 0 !important;
    box-sizing: border-box;
  }

  .page,
  .box_1 {
    overflow-x: hidden;
  }

  .license-content {
    width: 100%;
    height: auto !important;
    min-height: calc(100vh - 120px);
    padding: 24px 12px calc(84px + env(safe-area-inset-bottom));
    gap: 20px;
    justify-content: flex-start !important;
    box-sizing: border-box;
  }

  .license-content > div {
    width: 100%;
    padding: 10px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 4px 18px rgba(0, 0, 0, .08);
    box-sizing: border-box;
  }

  .license-image {
    width: 100% !important;
    height: auto !important;
    display: block;
    object-fit: contain;
  }
}
</style>

<style lang="less" scoped>
.new-el-upload-mdjy-none-h5 {
  background-color: #f5f5f5;
  border: 1px dashed #cccccc;
  width: 350px;
  height: 224px;
  display: inline-block;
  text-align: center;
  padding-top: 20px;
}

.triangle-h5 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 590px;
  height: 45px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
  border-radius: 6px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  text-align: center;
  position: relative;
  border: 0px solid #999999;
}

.triangle-h5:before {
  position: absolute;
  content: "";
  top: -10px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 12px solid #99999991;
}

/* 白色覆盖*/
.triangle-h5:after {
  position: absolute;
  content: "";
  /*减少两像素*/
  top: -8px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #ffffff;
}

.is-active {
  border-bottom: 4px solid #063F95;
}

/deep/ .shuru {
  position: absolute;
  bottom: 0;
  width: 289px;
  height: 118px;
  background: #FFFFFF;
  border-radius: 0px 0px 6px 6px;
  display: flex;
  flex-flow: column;
  align-items: flex-end;

  .el-textarea__inner {
    border: 0 !important;
    resize: none;
  }

  textarea {
    resize: none; /* 禁止用户调整 <textarea> 的大小 */
  }

  textarea::-webkit-resizer {
    display: none; /* 针对 WebKit 内核的浏览器，如 Chrome 和 Safari */
  }
}

/deep/ .new-el-upload-mdjy-display-h5 {
  .el-upload {
    display: none;
  }
}

.main-index {
  min-width: 768px;
  width: 100%;

  .header {
    width: 100%;
    height: 88px;
    background: #E6E6E6;
    display: flex;

    .title_hide {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      background: #e6e6e6;
    }

    .login {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      align-items: center;
      display: flex;
      height: 100%;
      margin-left: 33px;
    }

    .selected {
      position: fixed;
      width: 201px;
      background: #FFFFFF;
      box-shadow: 0px 5px 10px 0px rgba(116, 114, 114, 0.51);
      z-index: 100;
      top: 90px;
      right: 31px;
      text-align: center;

      div {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 72px;
      }
    }

    .select {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 1;
      margin-right: 30px;

      .select-option {
        width: 48px;
        height: 11px;
        display: flex;

        div {
          height: 11px;
          width: 11px;
          background: #333333;
          margin-left: 5px;
          border-radius: 50%;
        }
      }

    }
  }

  .trans-main {
    min-width: 765px;
    width: 100%;
    background: #f5f5f5;
    display: flex;
    flex-flow: column;
    align-items: center;
    border-bottom: 1px solid #DDDDDD;

    .trans-header {
      width: 100%;
      height: 80px;
      background: #FFFFFF;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      justify-content: center;

      .trans-header-select {
        width: 765px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        div {
          margin: 0 34px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 72px;
          height: 74px;
        }
      }

    }

    .trans-main-content {
      width: 768px;
      min-height: 993px;
      background: #FFFFFF;

      .trans-main-content-ok {
        height: 689px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;

        .trans-main-content-ok-font {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 1px;

          div:nth-child(1) {
            margin-right: 14px;
          }
        }

        .trans-main-content-ok-button {
          width: 261px;
          height: 60px;
          background: #063F95;
          border-radius: 35px 0px 35px 0px;
          margin-top: 48px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #F5F5F5;
          line-height: 52px;
          text-align: center;
        }
      }

      .trans-main-content-select {
        width: 100%;
        margin-top: 51px;
        margin-bottom: 113px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          margin: 0 90px;
        }

        /deep/ .el-select {
          .el-input {
            width: 200px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;

            input {
              border: 0;
              padding: 0;
              text-align: center;
            }

            .el-input__suffix {
              display: none;
            }
          }
        }
      }

      /deep/ .demo-form-inline-h5 {
        .el-upload-dragger {
          height: 415px;
          width: 711px;
          border: 2px dashed #d9d9d9;

          .new-el-upload-mdjy-h5 {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            line-height: 30px;
            cursor: pointer;

            .content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              .el-upload-titjy {
                font-family: "Microsoft YaHei";
                font-weight: 400;
                font-size: 24px;
                color: #333333;
                margin-bottom: 20px;
              }

              .scbncg {
                font-family: "Microsoft YaHei";
                font-weight: 400;
              }

              .uptitle {
                margin-top: 40px;
                font-family: "Source Han Sans CN";
                font-weight: 400;
                font-size: 24px;
                display: flex;
                width: 261px;
                height: 60px;
                align-items: center;
                justify-content: center;
                background: #063F95;
                border-radius: 26px 0px 26px 0px;
                color: #F5F5F5;
              }
            }
          }
        }

        .el-upload-list {
          margin-bottom: 30px !important;
          margin-right: -55px;
          margin-top: -60px;

          .el-upload-list__item .el-progress {
            position: absolute;
            top: 38px;
            width: 623px;
          }

          .el-progress__text {
            font-size: 24px !important;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }

          .el-upload-list__item .el-progress__text {
            position: absolute;
            right: 0;
            top: -26px;
          }

          .el-upload-list__item {
            text-align: left;
            transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 1.8;
            margin-top: 53px;
            position: relative;
            box-sizing: border-box;
            border-radius: 4px;
            width: 623px;

            .el-upload-list__item-name {
              color: #999999 !important;
              width: 560px;
            }

            .el-icon-document {
              position: absolute;
              margin-left: -69px;
              margin-top: -2.5px;
              font-size: 45px;
              color: #bebebe;
            }

            .el-progress-bar__outer {
              height: 17px !important;
            }

            .el-progress-bar__inner {
              background-color: #4dbe92 !important;
            }

            .el-icon-upload-success {
              display: none;
              color: #67c23a;
              position: absolute;
              margin-left: 19px;
              margin-top: 7.5px;
              font-size: 26px;
            }
          }
        }
      }

      /deep/ .new-el-upload-manjy-h5 {
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .el-divider.el-divider--horizontal {
          width: 470px;
          margin: 0;

          .el-divider__text.is-center {
            font-size: 24px;
            font-family: "Microsoft YaHei";
            color: #999999;
          }
        }

      }

      .list {
        margin-top: 70px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 80%;

        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #999999;

          span {
            margin-top: 10px;
          }
        }
      }

      .text-input {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        /deep/ .originaltext {
          width: 704px;

          /deep/ .el-input__count {
            color: #909399;
            position: absolute;
            font-size: 24px;
            bottom: 5px;
            right: 10px;
          }

          .el-textarea__inner {
            border: 0;
          }
        }
      }
    }

    .trans-main-content-text {
      width: 704px;
      height: 480px;
      background: #FFFFFF;
      box-shadow: 0px 5px 5px 0px rgba(3, 27, 63, 0.1);

      .trans-main-content-select {
        width: 100%;
        margin-top: 51px;
        margin-bottom: 50px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          margin: 0 90px;
        }

        /deep/ .el-select {
          .el-input {
            width: 200px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;

            input {
              border: 0;
              padding: 0;
              text-align: center;
            }

            .el-input__suffix {
              display: none;
            }
          }
        }
      }

      /deep/ .demo-form-inline-h5 {
        .el-upload-dragger {
          height: 320px;
          width: 711px;
          border: 2px dashed #d9d9d9;

          .new-el-upload-mdjy-h5 {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            line-height: 30px;
            cursor: pointer;

            .content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              .el-upload-titjy {
                font-family: "Microsoft YaHei";
                font-weight: 400;
                font-size: 24px;
                color: #333333;
                margin-bottom: 20px;
              }

              .scbncg {
                font-family: "Microsoft YaHei";
                font-weight: 400;
              }

              .uptitle {
                margin-top: 40px;
                font-family: "Source Han Sans CN";
                font-weight: 400;
                font-size: 24px;
                display: flex;
                width: 261px;
                height: 60px;
                align-items: center;
                justify-content: center;
                background: #063F95;
                border-radius: 26px 0px 26px 0px;
                color: #F5F5F5;
              }
            }
          }
        }

        .el-upload-list {
          margin-bottom: 30px !important;
          margin-right: -55px;
          margin-top: -60px;

          .el-upload-list__item .el-progress {
            position: absolute;
            top: 38px;
            width: 623px;
          }

          .el-progress__text {
            font-size: 24px !important;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }

          .el-upload-list__item .el-progress__text {
            position: absolute;
            right: 0;
            top: -26px;
          }

          .el-upload-list__item {
            text-align: left;
            transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 1.8;
            margin-top: 53px;
            position: relative;
            box-sizing: border-box;
            border-radius: 4px;
            width: 623px;

            .el-upload-list__item-name {
              color: #999999 !important;
              width: 560px;
            }

            .el-icon-document {
              position: absolute;
              margin-left: -69px;
              margin-top: -2.5px;
              font-size: 45px;
              color: #bebebe;
            }

            .el-progress-bar__outer {
              height: 17px !important;
            }

            .el-progress-bar__inner {
              background-color: #4dbe92 !important;
            }

            .el-icon-upload-success {
              display: none;
              color: #67c23a;
              position: absolute;
              margin-left: 19px;
              margin-top: 7.5px;
              font-size: 26px;
            }
          }
        }
      }

      /deep/ .new-el-upload-manjy-h5 {
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .el-divider.el-divider--horizontal {
          width: 470px;
          margin: 0;

          .el-divider__text.is-center {
            font-size: 24px;
            font-family: "Microsoft YaHei";
            color: #999999;
          }
        }

      }

      .list {
        margin-top: 70px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 80%;

        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #999999;

          span {
            margin-top: 10px;
          }
        }
      }

      .text-input {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        /deep/ .originaltext {
          width: 704px;

          .el-input__count {
            color: #909399;
            position: absolute;
            font-size: 24px;
            bottom: 5px;
            right: 10px;
          }

          .el-textarea__inner {
            border: 0;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
          }
        }
      }
    }

    .trans-main-content-text-tip {
      margin-bottom: 474px;
      margin-top: 20px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      width: 704px;
    }
  }

  .main-foot {
    height: 149px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 667px;
      height: 64px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233E;
      line-height: 36px;
    }
  }
}

/deep/ .payClass1 {
  .el-dialog {
    min-width: 800px;
  }

  .el-dialog__footer {
    padding: 10px 30px 20px !important;
    line-height: 41px;
  }

  .el-dialog__body {
    padding: 30px 30px !important;
  }

  .el-dialog__header {
    padding: 20px 30px 10px !important;
    line-height: 50px;
  }

}

/deep/ .payClass2 {
  .el-dialog {
    width: 600px;
  }

  .el-dialog__footer {
    padding: 10px 30px 20px !important;
    line-height: 41px;
  }

  .el-dialog__body {
    padding: 10px 30px !important;
  }

  .el-dialog__header {
    padding: 5px 30px 10px !important;
    line-height: 50px;
  }

}

/deep/ .dialog-title {
  text-align: left;
  width: 100%;
  margin-bottom: 30px;

  .el-form--inline .el-form-item, .el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: baseline;
    margin: 0;
    padding: 0;
  }
}

.fanyiyuyan {
  font-size: 18px;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
  color: #333333;
  float: left;
  line-height: 48px;
}

.demo-form-inline {
  float: left;
}

.okTranslate {
  border-color: #3E6D77;
  width: 142px;
  height: 40px;
  background: #3E6D77;
  border-radius: 2px;
  font-size: 14px;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
}

/deep/ .borderSelect {
  .el-input--suffix .el-input__inner {
    border: 0;
    width: 125px;
    font-size: 16px;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    color: #333333;
  }

  .el-input__suffix {
    right: 0px;
  }
}

/deep/ .borderNewSelect {
  .el-select {
    width: 150px !important;
  }
}

/deep/ .borderNewSelect2 {
  .el-select {
    width: 115px !important;
  }
}

/deep/ .borderNewSelect3 {
  .el-select {
    width: 120px !important;
  }
}

/deep/ .query {
  .el-input-group__append {
    background-color: #3e6d77;
    color: #fff;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }
}

.left-yijian-wx {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 55px;
  right: 0;
  font-family: 'Microsoft YaHei';
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #EAEAEA;
}

.left-yijian-qq {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 105px;
  right: 0;
  font-family: 'Microsoft YaHei';
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #EAEAEA;
}

.left-yijian {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 166px;
  right: 0;
  font-family: 'Microsoft YaHei';
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
}

.active-lab {
  background: #063F95 !important;
  color: #F5F5F5 !important;
  z-index: 1 !important;
}

/deep/ .new-el-upload-mdjy-display {
  .el-upload {
    display: none;
  }
}

.new-el-upload-mdjy-none {
  //background-color: #f5f5f5;
  //border: 1px dashed #cccccc;
  //width: 350px;
  //height: 224px;
  display: inline-block;
  text-align: center;
  //padding-top: 20px;
}

.mains {
  min-width: 1250px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  //background: url("../assets/img/trans1.jpg") #F5F5F5 no-repeat center top;
  background-size: 100% 1080px;

  .header {
    display: flex;
    width: 1200px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 80px;

    .header-left {
      display: flex;
      width: 135px;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
    }

    .header-right {
      display: flex;
      flex: 1;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;

      .title_hide {

      }

      div:nth-child(3) {
        height: 30px;
        width: 68px;
        background-color: #063F95;
        border-radius: 3px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-right: 10px;
        cursor: pointer;
      }

      div:nth-child(4) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
        margin-left: 10px;
        cursor: pointer;
      }

      div:nth-child(5) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #DDDDDD;
        cursor: pointer;
      }

      div:nth-child(7) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
      }

      div:nth-child(6) {
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        margin-right: 10px;

        .el-button--text {
          color: #333333;
        }
      }

      div:nth-child(3):hover {
        background-color: #1565dc;
      }
    }
  }

  .line-hr {
    display: flex;
    width: 100%;
    height: 1px;
    background: #DDDDDD;
    border: 0;
  }

  .nav {
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 58px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    //background: #ffffff;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;

    .nav-border {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: 56px;
      background: #e6e6e6;

      div {
        display: flex;
        width: 1200px;
        justify-content: flex-start;
        align-items: center;

        label {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-items: center;
          width: 10%;
          cursor: pointer;

          .index {
            display: flex;
            width: 64px;
            height: 58px;
            color: #0049B9;
            border-bottom: 2px solid #0049B9;
            justify-content: center;
            align-items: center;
            padding: 0;
          }

          div:nth-child(1):hover {
            width: 38px;
            height: 58px;
            color: #0049B9;
            border-bottom: 2px solid #0049B9;
            justify-content: center;
            align-items: center;
          }
        }

        label:nth-child(1) {
          width: 7%;
        }

        label:nth-child(2) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049B9;
            border-bottom: 2px solid #0049B9;
          }
        }

        label:nth-child(3) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049B9;
            border-bottom: 2px solid #0049B9;
          }
        }

        label:nth-child(4) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049B9;
            border-bottom: 2px solid #0049B9;
          }
        }

        label:nth-child(5) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049B9;
            border-bottom: 2px solid #0049B9;
          }
        }
      }
    }
  }

  /deep/ .tip-alert {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;

    .el-alert.is-center {
      background: #ffe4cc !important;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffa557;
      height: 37px;
    }
  }

  .title {
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 31px;
    margin-bottom: 54px;
    font-size: 36px;
    font-family: "Source Han Sans CN";
    font-weight: bold;
    color: #373737;
    cursor: pointer;

    div {
      display: flex;
      width: 1200px;
      justify-content: center;
      align-items: center;
    }
  }

  .check-lab {
    margin-top: 60px;
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    min-height: 860px;

    .lab {
      display: flex;
      width: 1200px;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 40px;

      div {
        justify-content: center;
        align-items: center;
        display: flex;
        width: 260px;
        height: 48px;
        font-size: 18px;
        font-family: "Source Han Sans CN";
        font-weight: 400;
        background: white;
        border-radius: 26px 0px 26px 0px;
        cursor: pointer;
        color: #333333;
      }

      div:nth-child(2) {
        margin: 0px -30px;
      }
    }

    .uploads {
      display: flex;
      width: 1200px;
      min-height: 770px;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background: white;

      .uploads-main {
        display: flex;
        width: 1200px;
        min-height: 720px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .new-form-jy {
          display: flex;
          width: 1200px;
          height: 60px;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          font-family: "Source Han Sans CN";
          font-size: 14px;
          color: #333333;
          border-bottom: 1px solid #DDDDDD;

          div {
            display: flex;
            width: 1170px;
            align-items: center;
            justify-content: center;
            margin-bottom: 13px;

            div {
              display: flex;
              width: 100%;
              align-items: center;
              justify-content: space-around;
            }

            div:nth-child(2) {
              width: 80%;
            }
          }
        }

        /deep/ .new-upload-demo {
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;

          .el-upload-dragger {
            height: 281px;
            width: 1075px;
            border: 2px dashed #d9d9d9;

            .new-el-upload-mdjy {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: 100%;
              line-height: 30px;
              cursor: pointer;

              .content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .el-upload-titjy {
                  font-family: "Microsoft YaHei";
                  font-weight: 400;
                  font-size: 16px;
                  color: #333333;
                }

                .scbncg {
                  font-family: "Microsoft YaHei";
                  font-weight: 400;
                }

                .uptitle {
                  margin-top: 40px;
                  font-family: "Source Han Sans CN";
                  font-weight: 400;
                  font-size: 18px;
                  display: flex;
                  width: 260px;
                  height: 48px;
                  align-items: center;
                  justify-content: center;
                  background: #063F95;
                  border-radius: 26px 0px 26px 0px;
                  color: #F5F5F5;
                }
              }
            }
          }

          .el-upload-list {
            margin-bottom: 30px !important;

            .el-upload-list__item {
              text-align: left;
              transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
              font-size: 14px;
              color: #606266;
              line-height: 1.8;
              margin-top: 20px;
              position: relative;
              box-sizing: border-box;
              border-radius: 4px;
              width: 300px;

              .el-icon-document {
                position: absolute;
                margin-left: -49px;
                margin-top: -2.5px;
                font-size: 26px;
                color: #bebebe;
              }

              .el-progress-bar__outer {
                height: 7px !important;
              }

              .el-progress-bar__inner {
                background-color: #4dbe92 !important;
              }

              .el-icon-upload-success {
                color: #67c23a;
                position: absolute;
                margin-left: 19px;
                margin-top: 7.5px;
                font-size: 26px;
              }
            }
          }
        }

        /deep/ .new-upload-demo2 {
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;

          .el-upload-dragger {
            height: 281px;
            width: 1075px;
            border: 2px dashed #d9d9d9;

            .new-el-upload-mdjy {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: 100%;
              line-height: 30px;
              cursor: pointer;

              .content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .el-upload-titjy {
                  font-family: "Microsoft YaHei";
                  font-weight: 400;
                  font-size: 16px;
                  color: #333333;
                }

                .scbncg {
                  font-family: "Microsoft YaHei";
                  font-weight: 400;
                }

                .uptitle {
                  margin-top: 40px;
                  font-family: "Source Han Sans CN";
                  font-weight: 400;
                  font-size: 18px;
                  display: flex;
                  width: 260px;
                  height: 48px;
                  align-items: center;
                  justify-content: center;
                  background: #063F95;
                  border-radius: 26px 0px 26px 0px;
                  color: #F5F5F5;
                }
              }
            }
          }

          .el-upload-list {
            margin-bottom: 30px !important;

            .el-upload-list__item {
              text-align: left;
              transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
              font-size: 14px;
              color: #606266;
              line-height: 1.8;
              margin-top: 20px;
              position: relative;
              box-sizing: border-box;
              border-radius: 4px;
              width: 300px;

              .el-icon-document {
                position: absolute;
                margin-left: -49px;
                margin-top: -2.5px;
                font-size: 26px;
                color: #bebebe;
              }

              .el-progress-bar__outer {
                height: 7px !important;
              }

              .el-progress-bar__inner {
                background-color: #4dbe92 !important;
              }

              .el-icon-upload-success {
                color: #67c23a;
                position: absolute;
                margin-left: 19px;
                margin-top: 7.5px;
                font-size: 26px;
              }
            }
          }
        }

        /deep/ .new-el-upload-manjy {
          width: 560px;
          margin-bottom: 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .el-divider.el-divider--horizontal {
            width: 470px;
            margin: 0;

            .el-divider__text.is-center {
              font-size: 16px;
              font-family: "Microsoft YaHei";
              color: #999999;
            }
          }

        }

        .list {
          margin-top: 45px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          width: 90%;

          div {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #999999;

            span {
              margin-top: 10px;
            }
          }
        }

        .text-input {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          /deep/ .originaltext {
            width: 600px;

            .el-textarea__inner {
              border: 0;
            }
          }
        }
      }
    }
  }

  .active {
    color: #063F95 !important;
  }

  /deep/ .languages {
    width: 66px;
    padding: 0px 15px;
    float: left;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    cursor: pointer;

    .el-input__suffix {
      background: url("../assets/img/sanjiao.png") no-repeat;
      transform: translate(15px, 18px);
    }

    .el-icon-arrow-up:before {
      content: "";
    }

    .el-input__icon:after {
      content: "";
    }

    .el-input__inner {
      width: 0 !important;
      border: 0;
      padding: 0;
      margin: 0;
    }
  }

  /deep/ .openlanguages {
    width: 66px;
    padding: 0px 15px;
    float: left;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    cursor: pointer;

    .el-input__inner {
      width: 0 !important;
      border: 0;
      padding: 0;
      margin: 0;
    }
  }

  .foot {
    display: flex;
    width: 100%;
    background: #F5F5F5;
    height: 80px;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #dddddd;
    flex-flow: column;

    span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233E;
      line-height: 28px;
    }
  }

}

</style>

<style lang="less" scoped>
@media (max-width: 768px) {
  .page,
  .page > .group_1,
  .page > .group_1 > .box_1 {
    width: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    overflow-x: hidden !important;
    box-sizing: border-box;
  }
}
</style>
